import {
  Component, OnInit, Input, Output, EventEmitter, ElementRef, QueryList, ViewChildren,

} from '@angular/core';
import { EnumModel } from '../../shared/objects/EnumModel';
import { VenueDetailsService } from './venue-details.service';
import {
  VenueDetailsModel, VenueDetailsImage, VenueDetailsSubsidiaryData, VenueDetailsContact,
  VenueDetailsOffer, VenueDetailsVisit, GroupVenueListResponseModel,
  VenuePositionListModel, VenuePositionListItemModel, SelectListItem
} from './venue-details.model';



import { } from '@types/googlemaps';
import { Toast, ToasterService } from 'angular2-toaster';
import { StatisticsGroupModel } from '../../shared/objects/statistics-group.model';
import { DatePipe } from "@angular/common";
import { SliderComponent } from "../../shared/slider/slider.component";

import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { GroupedEnumModel } from 'app/shared/objects/GroupedEnumModel';
import { appendDateWithSuffix, convertToUTCDate } from './date-helper-venue';
import { StatusChange } from 'app/shared/contants/change-action-status';

@Component({
  selector: 'app-venue-details',
  templateUrl: './venue-details.component.html',
  providers: [VenueDetailsService],
  styleUrls: ['./venue-details.component.less', '../../../../node_modules/ng2-dnd/style.css']
})
export class VenueDetailsComponent implements OnInit {
  disableConfirmButton: boolean = true;
  pendingVenueType: EnumModel;
  barCuisineChange: boolean;
  restaurantCuisineChange: boolean;
  changeVenueType: boolean;

  venueTypeChanged: boolean;
  offersInitiatedOnceRestaurant: any;
  statusHasChangedBar: boolean;
  statusHasChangedRestaurant: boolean;
  initialState: string;
  map: any;
  geocoder: any = new google.maps.Geocoder();
  perkDescription = '';
  isBulkNotifications = false;

  @Input() showVenue: boolean;
  @Input() selectedVenueId: number;
  @Input() selectedGroupId: number; // for new Venues
  @Output() showVenueChange = new EventEmitter<boolean>();
  @Output() switchVenueEvent = new EventEmitter<number>();
  @Output() switchToGroupEvent = new EventEmitter<number>();
  @Output() newVenueEvent = new EventEmitter<number>();

  buttonsEnabled = true;

  selectedVenueType: EnumModel;
  venueTypesOptions: EnumModel[];

  selectedPeriod = 'Current Month';
  periodOptions = ['Current Month'];

  selectedLocation: EnumModel;
  locationOptions: EnumModel[];

  selectedSubArea: EnumModel;
  subAreaOptions: EnumModel[];
  allSubAreas: GroupedEnumModel[];
  newSubArea: "";
  allCuisines: EnumModel[];
  cuisineOptions: SelectListItem[];
  editSubAreaOptions: SelectListItem[];
  newCuisine: "";
  allVibes: EnumModel[];
  vibeOptions: SelectListItem[];
  newVibe = "";

  selectedOfferOptionRestaurant: EnumModel;
  offerOptionsRestaurant: EnumModel[];

  selectedOfferOptionBar: EnumModel;
  offerOptionsBar: EnumModel[];

  priceOptions: EnumModel[];
  selectedBarPrice: EnumModel;
  selectedRestaurantPrice: EnumModel;

  selectedRestaurantStatus: EnumModel;
  restaurantStatusOptions: EnumModel[];

  selectedVisitsHistoryPeriod: EnumModel;
  visitsHistoryPeriodOptions: EnumModel[];

  maxPartySizeOptionsBar: EnumModel[];
  maxPartySizeOptionsRestaurant: EnumModel[];

  offerOptionsRestaurantDirty = false;
  maxPartySizeOptionsRestaurantDirty = false;
  offerOptionsBarDirty = false;
  maxPartySizeOptionsBarDirty = false;

  selectedBarStatus: EnumModel;
  barStatusOptions: EnumModel[];
  venue: VenueDetailsModel;
  venueGroup: GroupVenueListResponseModel;
  addSubArea = false;
  addContact = false;
  showGroupHasNoContact = false;
  deleteVenue = false;
  deleteCuisinesConfirm = false;
  deleteVibesConfirm = false;
  deleteSubAreasConfirm = false;
  switchVenue = false;
  switchVenueDestination: number;
  saveVenue = false;
  changeRestaurantStatus = false;
  changeBarStatus = false;
  showAppPositionBar = false;
  showAppPositionRestaurant = false;
  activeTab = 1;
  activeDetailsType = 1; // 1 - Restaurant, 2 - Bar

  showOTFakeValueRestaurant = false;
  showOTDropdownRestaurant = false;
  showPSFakeValueRestaurant = false;
  showPSDropdownRestaurant = false;

  showOTFakeValueBar = false;
  showOTDropdownBar = false;
  showPSFakeValueBar = false;
  showPSDropdownBar = false;

  fakeOfferTypeRestaurantMessage: string;
  fakeOfferTypeBarMessage: string;
  fakeMaxPartySizeRestaurantMessage: string;
  fakeMaxPartySizeBarMessage: string;

  showSwitchToGroup = false;


  editCuisinesRestaurant = false;
  editCuisinesBar = false;
  editVibesRestaurant = false;
  editVibesBar = false;
  // generated flags
  hasBar = false;
  hasRestaurant = false;
  barSubsidiaryData: VenueDetailsSubsidiaryData;
  restaurantSubsidiaryData: VenueDetailsSubsidiaryData;

  // Contacts adding modification
  selectedContact: VenueDetailsContact;
  selectedContactIndex: -1;

  // Visits
  revenueForPeriod = 0;
  coversForPeriod = 0;
  transactionsForPeriod = 0;
  perksVisitsForPeriod = 0;
  filteredVisits: VenueDetailsVisit[];

  // Offers
  restaurantOffers: VenueDetailsOffer[] = new Array<VenueDetailsOffer>();
  barOffers: VenueDetailsOffer[] = new Array<VenueDetailsOffer>();
  offerRateOptions: EnumModel[];

  pendingRestaurantStatus: EnumModel;
  pendingBarStatus: EnumModel;

  selectedMaxPartySizeBar: EnumModel;
  selectedMaxPartySizeRestaurant: EnumModel;

  currentVenueOrderListBar: VenuePositionListModel;
  currentVenueOrderListIndexBar: number;
  currentVenueOrderListVenueBar: any;

  currentVenueOrderListRestaurant: VenuePositionListModel;
  currentVenueOrderListIndexRestaurant: number;
  currentVenueOrderListVenueRestaurant: any;

  currentVenueOrderListType: string;

  statisticsGroupModel: StatisticsGroupModel[];
  onlyBars = false;
  onlyRestaurants = false;
  bothSubgroups = false;

  barUploadImgNumExceed = false;

  showAddCover = false;
  // barUploadImgNum: number = 0;

  restaurantImages = new Array<VenueDetailsImage>();
  perkImages: Array<VenueDetailsImage> = [];
  barImages = new Array<VenueDetailsImage>();

  offerTypeChangeBarLabel: string;
  maxPartySizeChangeBarLabel: string;
  offerTypeChangeRestaurantLabel: string;
  maxPartySizeChangeRestaurantLabel: string;

  mondayRestaurantOfferLabel: string;
  tuesdayRestaurantOfferLabel: string;
  wednesdayRestaurantOfferLabel: string;
  thursdayRestaurantOfferLabel: string;
  fridayRestaurantOfferLabel: string;
  saturdayRestaurantOfferLabel: string;
  sundayRestaurantOfferLabel: string;

  mondayBarOfferLabel: string;
  tuesdayBarOfferLabel: string;
  wednesdayBarOfferLabel: string;
  thursdayBarOfferLabel: string;
  fridayBarOfferLabel: string;
  saturdayBarOfferLabel: string;
  sundayBarOfferLabel: string;

  oldOffersRestaurant = new Array<VenueDetailsOffer>();
  oldOffersBar = new Array<VenueDetailsOffer>();
  initialLoadRestaurant: boolean;
  initialLoadBar: boolean;

  public latitude: number;
  public longitude: number;
  public zoom: number;
  public styles: any;
  public closeVenue = false;
  private offersInitiatedOnceBar: boolean;
  public changeTabAfterInit: boolean;

  @ViewChildren(SliderComponent)
  public sliderComponents: QueryList<SliderComponent>;
  private initialOffersState: string;
  private initialOffersRestaurantState: string;
  private initialOffersBarState: string;


  disableOfferTypeRestaurant = false;
  disableMaxPartySizeRestaurant = false;
  disableOfferTypeBar = false;
  disableMaxPartySizeBar = false;
  days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday'];
  daysWeekends = ['Friday', 'Saturday', 'Sunday'];
  indexOfFriday = 4;
  perkMaxSize = 250;
  perkLabelText = 'Perk';

  initFields() {
    this.initialState = null;
    this.map = null;
    this.geocoder = new google.maps.Geocoder();
    this.buttonsEnabled = true;
    this.selectedVenueType = null;
    this.venueTypesOptions = null;
    this.selectedPeriod = 'Current Month';
    this.periodOptions = ['Current Month'];
    this.selectedLocation = null;
    this.locationOptions = null;
    this.priceOptions = [{ id: 1, name: "£" }, { id: 2, name: "££" }, { id: 3, name: "£££" }, { id: 4, name: "££££" }];
    this.selectedBarPrice = null;
    this.selectedRestaurantPrice = null;
    this.selectedOfferOptionRestaurant = null;
    this.offerOptionsRestaurant = null;
    this.selectedOfferOptionBar = null;
    this.offerOptionsBar = null;
    this.selectedRestaurantStatus = null;
    this.restaurantStatusOptions = null;
    this.selectedVisitsHistoryPeriod = null;
    this.visitsHistoryPeriodOptions = null;
    this.maxPartySizeOptionsBar = null;
    this.maxPartySizeOptionsRestaurant = null;
    this.selectedBarStatus = null;
    this.barStatusOptions = null;
    this.venue = null;
    this.venueGroup = null;
    this.addContact = false;
    this.addSubArea = false;
    this.showGroupHasNoContact = false;
    this.deleteVenue = false;
    this.switchVenue = false;
    this.switchVenueDestination = null;
    this.saveVenue = false;
    this.showAppPositionBar = false;
    this.showAppPositionRestaurant = false;
    this.activeTab = 1;
    this.activeDetailsType = 1; // 1 - Restaurant, 2 - Bar
    this.showSwitchToGroup = false;
    // this.hasBar = false;
    // this.hasRestaurant = false;
    this.barSubsidiaryData = null;
    this.restaurantSubsidiaryData = null;
    this.selectedContact = null;
    this.selectedContactIndex = -1;
    this.revenueForPeriod = 0;
    this.coversForPeriod = 0;
    this.transactionsForPeriod = 0;
    this.perksVisitsForPeriod = 0;
    this.filteredVisits = null;
    // this.restaurantOffers = null;
    // this.barOffers = null;
    this.offerRateOptions = null;
    this.selectedMaxPartySizeBar = null;
    this.selectedMaxPartySizeRestaurant = null;
    this.currentVenueOrderListBar = null;
    this.currentVenueOrderListIndexBar = null;
    this.currentVenueOrderListVenueBar = null;
    this.currentVenueOrderListRestaurant = null;
    this.currentVenueOrderListIndexRestaurant = null;
    this.currentVenueOrderListVenueRestaurant = null;
    this.currentVenueOrderListType = null;
    this.statisticsGroupModel = null;
    this.onlyBars = false;
    this.onlyRestaurants = false;
    this.bothSubgroups = false;
    this.barUploadImgNumExceed = false;
    this.showAddCover = false;
    this.restaurantImages = new Array<VenueDetailsImage>();
    this.perkImages = new Array<VenueDetailsImage>();
    this.barImages = new Array<VenueDetailsImage>();
    this.latitude = null;
    this.longitude = null;
    this.zoom = null;
    this.styles = null;
    this.closeVenue = false;


    this.offerOptionsRestaurantDirty = false;
    this.maxPartySizeOptionsRestaurantDirty = false;
    this.offerOptionsBarDirty = false;
    this.maxPartySizeOptionsBarDirty = false;

    this.restaurantOffers = new Array();
    this.barOffers = new Array();

    this.offersInitiatedOnceRestaurant = false;
    this.offersInitiatedOnceBar = false;
    this.venueTypeChanged = false;

    this.showPSFakeValueRestaurant = false;
    this.showPSFakeValueBar = false;
    this.showOTFakeValueRestaurant = false;
    this.showOTFakeValueBar = false;
  }

  constructor(private venueDetailsService: VenueDetailsService, private toasterService: ToasterService, private element: ElementRef) {
  }

  ngOnInit() {

    let changeTab = 0;
    if (this.changeTabAfterInit) {
      changeTab = this.activeTab;
    }

    this.changeTabAfterInit = false;

    this.initialLoadRestaurant = true;
    this.initialLoadBar = true;
    this.initFields();
    if (!this.selectedVenueId) { // new Venue
      this.venueDetailsService.getVenueDetailsEnums().subscribe((enums) => {
        this.venueTypesOptions = enums.venueType;
        this.locationOptions = enums.location;
        this.restaurantStatusOptions = enums.status;
        this.barStatusOptions = enums.status;
        this.venueDetailsService.getVenueGroupList(this.selectedGroupId).subscribe(
          (group) => {
            this.venueGroup = group;
            this.venue = new VenueDetailsModel();
            this.venue.groupId = this.selectedGroupId;
            this.initFromModel(changeTab);
          });
      });

      this.venueDetailsService.getSubAreasList().subscribe((list) => {
        this.allSubAreas = list.map(z => new GroupedEnumModel(z.id, z.subAreas));
      });

      this.venueDetailsService.getCuisineList().subscribe((list) => {
        this.allCuisines = list;
      });

      this.venueDetailsService.getVibeList().subscribe((list) => {
        this.allVibes = list;
      });

    } else {
      this.venueDetailsService.getVenueAnalytisc(this.selectedVenueId)
        .subscribe(
          (response) => {
            this.statisticsGroupModel = response;
            for (const group of this.statisticsGroupModel) {
              if (group.name !== 'Demographic') {
                if (group.statisticsSubgroups.length === 2) {
                  this.bothSubgroups = true;
                  this.onlyRestaurants = false;
                  this.onlyBars = false;
                  break;
                } else {
                  for (const subGroup of group.statisticsSubgroups) {
                    if (subGroup.name === 'Restaurants') {
                      this.onlyRestaurants = true;
                      this.onlyBars = false;
                      this.bothSubgroups = false;
                    } else if (subGroup.name === 'Bars') {
                      this.onlyBars = true;
                      this.onlyRestaurants = false;
                      this.bothSubgroups = false;
                    }
                  }
                }
              }
            }
          },
          (error) => console.log(error)
        );


      this.venueDetailsService.getVenueDetailsEnums().subscribe((enums) => {
        this.venueTypesOptions = enums.venueType;
        this.locationOptions = enums.location;
        this.restaurantStatusOptions = enums.status;
        this.barStatusOptions = enums.status;
        this.venueDetailsService.getVenueDetails(this.selectedVenueId).subscribe(
          (response) => {
            this.venue = response;
            this.initFromModel(changeTab);
            this.venueDetailsService.getVenueGroupList(this.venue.groupId).subscribe(
              (group) => {
                this.venueGroup = group;
              }
            );
          }
        );
      });

      this.venueDetailsService.getSubAreasList().subscribe((list) => {
        this.allSubAreas = list.map(z => new GroupedEnumModel(z.id, z.subAreas));
      });

      this.venueDetailsService.getCuisineList().subscribe((list) => {
        this.allCuisines = list;
      });

      this.venueDetailsService.getVibeList().subscribe((list) => {
        this.allVibes = list;
      });

    }


  }

  VenueTypeChanged(initial) {

    if (!this.changeVenueType && this.venue.id) {
      this.changeVenueType = true;
      return;
    }

    if (this.selectedVenueType.id == null) {
      this.hasBar = this.hasRestaurant = true;
    } else {
      if (this.selectedVenueType.id === 'Bar') {
        this.hasBar = true;
        this.hasRestaurant = false;
      } else {
        this.hasBar = false;
        this.hasRestaurant = true;
      }
    }

    if (!initial) {
      this.venueTypeChanged = true;
    }

    this.changeVenueType = false;
  }

  confirmVenueTypeChange(item) {

    if (!this.venue.id) {
      this.VenueTypeChanged(false);
      return;
    }

    if (this.pendingVenueType.name === item.name) {
      return;
    } else {
      if (this.selectedVenueType.name === 'Bar and Restaurant') {
        if (this.pendingVenueType.name === 'Bar') {
          this.restaurantCuisineChange = true;
          this.barCuisineChange = false;
        } else {
          this.restaurantCuisineChange = false;
          this.barCuisineChange = true;
        }
      } else if (this.selectedVenueType.name === 'Bar') {
        this.restaurantCuisineChange = false;
        this.barCuisineChange = true;
      } else {
        this.restaurantCuisineChange = true;
        this.barCuisineChange = false;
      }

    }

    this.changeVenueType = true;
  }

  cancelVenueChange() {
    this.selectedVenueType = this.pendingVenueType;
    this.cancel();
  }

  venueTypeChangeConfirmed() {
    this.VenueTypeChanged(false);
    this.saveConfirmed();
  }

  initFromModel(changeTab) {
    this.initVenueType();
    this.initStatuses();
    this.initOffers(false, null);
    this.initLocation();
    this.initPrices();
    this.initVisits();

    this.initImages();
    // this.VenueTypeChanged(true);


    if (this.hasRestaurant) {
      if (!this.currentVenueOrderListRestaurant) {
        this.getVenuesOrder('Restaurant', false, true);
      }
    }

    if (this.hasBar) {
      if (!this.currentVenueOrderListBar) {
        this.getVenuesOrder('Bar', false, true);
      }
    }

    if (changeTab) {
      this.changeTab(changeTab);
    }

    this.SaveInitialState();
    this.SaveInitialOffersRestaurantState();
    this.SaveInitialOffersBarState();
  }

  initImages() {
    for (const img of this.venue.venueImages) {
      if (img.venueType === "Restaurant") {
        this.restaurantImages.push(img);
      } else if (img.venueType === "Bar") {
        this.barImages.push(img);
      }
    }
    for (const img of this.venue.perkImages) {
      if (img.isPerkImage) {
        this.perkImages.push(img);
      }
    }
  }


  addRestaurantImage(e) {
    const component = this;
    const files: any = <HTMLElement>e.target.files;
    for (let i = 0; i < files.length; i++) {
      if (this.restaurantImages.length > 3) {
        break;
      }
      const urlStringReader = new FileReader();
      const file = files[i];
      const type = file.type;

      if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
        const toast: Toast = {
          type: 'error',
          title: 'Error',
          body: 'File ' + file.name + ' is not an image',
          showCloseButton: true,
          timeout: 5000
        };

        this.toasterService.pop(toast);

        continue;
      }

      if (file.size > 1048576) {
        const toast: Toast = {
          type: 'error',
          title: 'Error',
          body: 'File ' + file.name + ' is larger then 1mb',
          showCloseButton: true,
          timeout: 5000
        };

        this.toasterService.pop(toast);

        continue;
      }

      urlStringReader.addEventListener('load', function (event: any) {
        if (component.restaurantImages.length < 3) {
          const src = event.target.result;
          const newRImage = new VenueDetailsImage();
          newRImage.venueType = 'Restaurant';
          newRImage.url = src;
          newRImage.data = file;
          newRImage.mimeType = type;
          component.restaurantImages.push(newRImage);
          e.target.value = '';
        }
      });
      urlStringReader.readAsDataURL(file);
    }
  }

  removeRestaurantImage(img) {
    this.restaurantImages.splice(this.restaurantImages.indexOf(img), 1);
  }

  removePerkImage(img) {
    this.perkImages.splice(this.perkImages.indexOf(img), 1);
  }

  addPerkImage(e) {

    const component = this;
    const files: any = <HTMLElement>e.target.files;
    for (let i = 0; i < files.length; i++) {
      if (this.perkImages.length > 0) {
        break;
      }
      const urlStringReader = new FileReader();
      const file = files[i];
      const type = file.type;

      if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
        const toast: Toast = {
          type: 'error',
          title: 'Error',
          body: 'File ' + file.name + ' is not an image',
          showCloseButton: true,
          timeout: 5000
        };

        this.toasterService.pop(toast);

        continue;
      }

      if (file.size > 1048576) {
        const toast: Toast = {
          type: 'error',
          title: 'Error',
          body: 'File ' + file.name + ' is larger then 1mb',
          showCloseButton: true,
          timeout: 5000
        };

        this.toasterService.pop(toast);

        continue;
      }

      urlStringReader.addEventListener('load', function (event: any) {
        if (component.perkImages.length < 1) {
          const src = event.target.result;
          const newRImage = new VenueDetailsImage();
          newRImage.venueType = 'Restaurant';
          newRImage.url = src;
          newRImage.data = file;
          newRImage.mimeType = type;
          component.perkImages.push(newRImage);
          e.target.value = '';
        }
      });
      urlStringReader.readAsDataURL(file);
    }
  }

  addBarImage(e) {
    const component = this;
    const files: any = <HTMLElement>e.target.files;
    for (let i = 0; i < files.length; i++) {
      if (this.barImages.length > 3) {
        break;
      }

      const urlStringReader = new FileReader();
      const file = files[i];
      const type = file.type;

      if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
        const toast: Toast = {
          type: 'error',
          title: 'Error',
          body: 'File ' + file.name + ' is not an image',
          showCloseButton: true,
          timeout: 5000
        };

        this.toasterService.pop(toast);

        continue;
      }

      if (file.size > 1048576) {
        const toast: Toast = {
          type: 'error',
          title: 'Error',
          body: 'File ' + file.name + ' is larger then 1mb',
          showCloseButton: true,
          timeout: 5000
        };

        this.toasterService.pop(toast);

        continue;
      }

      urlStringReader.addEventListener('load', function (event: any) {
        if (component.barImages.length < 3) {
          const src = event.target.result;
          const newRImage = new VenueDetailsImage();
          newRImage.venueType = 'Bar';
          newRImage.url = src;
          newRImage.data = file;
          newRImage.mimeType = type;
          component.barImages.push(newRImage);
          e.target.value = '';
        }
      });
      urlStringReader.readAsDataURL(file);
    }
  }

  removeBarImage(img) {
    this.barImages.splice(this.barImages.indexOf(img), 1);
  }

  initVenueType() {
    this.hasBar = false;
    this.hasRestaurant = false;
    if (!this.venue.id) {
      this.hasRestaurant = true;
    }

    console.log(this.venue);
    for (const subsidiary of (this.venue as any).subsidieries) {

      subsidiary.cuisinesString = subsidiary.cuisines.length + " cuisine" + (subsidiary.cuisines.length == 1 ? "" : "s");

      subsidiary.vibes = subsidiary.vibes || [];
      subsidiary.vibesString = subsidiary.vibes.length + " vibe" + (subsidiary.vibes.length == 1 ? "" : "s");

      if (subsidiary.type === 'Bar') {
        this.hasBar = true;
        this.barSubsidiaryData = subsidiary;
      }
      if (subsidiary.type === 'Restaurant') {
        this.hasRestaurant = true;
        this.restaurantSubsidiaryData = subsidiary;
      }
    }
    let type = '';
    if (this.hasBar) {
      if (this.hasRestaurant) {
        type = null;   // Bar and Restaurant
      } else {
        type = 'Bar';
      }
    } else {
      type = 'Restaurant';
    }
    for (const venueType of this.venueTypesOptions) {
      if (venueType.id === type) {
        this.selectedVenueType = venueType;
        break;
      }
    }
    if (!this.selectedVenueType) {
      this.selectedVenueType = this.venueTypesOptions[0];
    }
    if (!this.barSubsidiaryData) {
      this.barSubsidiaryData = new VenueDetailsSubsidiaryData();
      this.barSubsidiaryData.type = 'Bar';
    }
    if (!this.restaurantSubsidiaryData) {
      this.restaurantSubsidiaryData = new VenueDetailsSubsidiaryData();
      this.restaurantSubsidiaryData.type = 'Restaurant';
    }

    this.pendingVenueType = this.selectedVenueType;

    if (this.venue.perkDescription) {
      this.perkDescription = this.venue.perkDescription
    }

  }

  initLocation() {
    this.selectedLocation = null;
    for (const location of this.locationOptions) {
      if (this.venue.locationFilter === location.id) {
        this.selectedLocation = location;
      }
    }
    if (!this.selectedLocation) {
      this.selectedLocation = this.locationOptions[0];
    }

    this.latitude = this.venue.location.latitude;
    this.longitude = this.venue.location.longitude;

    for (const location of this.allSubAreas) {
      if (this.selectedLocation.id === location.id) {
        this.subAreaOptions = location.value;

        this.editSubAreaOptions = location.value.map(z => {
          return {
            id: z.id,
            name: z.name,
            selected: false
          }
        });

        this.subAreaOptions.unshift(new EnumModel(0, "Not selected"));
        this.subAreaOptions.push(new EnumModel(-1, "🖉 EDIT LIST"));
      }
    }

    this.selectedSubArea = null;
    for (const subArea of this.subAreaOptions) {
      if (this.venue.subAreaId === subArea.id) {
        this.selectedSubArea = subArea;
      }
    }

    if (!this.selectedSubArea) {
      this.selectedSubArea = this.subAreaOptions[0];
    }
  }


  refreshSubAreas() {
    for (const location of this.allSubAreas) {
      if (this.selectedLocation.id === location.id) {
        this.subAreaOptions = location.value;

        this.editSubAreaOptions = location.value.map(z => {
          return {
            id: z.id,
            name: z.name,
            selected: false
          }
        });

        if (this.subAreaOptions.length == 0 || this.subAreaOptions[0].id != 0) {
          this.subAreaOptions.unshift(new EnumModel(0, "Not selected"));
          this.subAreaOptions.push(new EnumModel(-1, "🖉 EDIT LIST"));
        }
      }
    }
    this.selectedSubArea = this.subAreaOptions[0];
  }

  initPrices() {
    for (const price of this.priceOptions) {
      if (this.barSubsidiaryData.price === price.id) {
        this.selectedBarPrice = price;
        break;
      } else {
        if (!this.selectedVenueId && price.id === 1) {
          this.selectedBarPrice = price;
          break;
        }
      }
    }
    if (!this.selectedBarPrice && this.priceOptions) {
      this.selectedBarPrice = this.priceOptions[0];
    }


    for (const price of this.priceOptions) {
      if (this.restaurantSubsidiaryData.price === price.id) {
        this.selectedRestaurantPrice = price;
        break;
      } else {
        if (!this.selectedVenueId && price.id === 1) {
          this.selectedRestaurantPrice = price;
          break;
        }
      }
    }
    if (!this.selectedRestaurantPrice && this.priceOptions) {
      this.selectedRestaurantPrice = this.priceOptions[0];
    }
  }

  initVisits() {
    this.visitsHistoryPeriodOptions = new Array();
    this.visitsHistoryPeriodOptions.push(new EnumModel('currentMonth', 'Current Month'));
    this.visitsHistoryPeriodOptions.push(new EnumModel('lastMonth', 'Last Month'));
    this.visitsHistoryPeriodOptions.push(new EnumModel('all', 'All'));
    this.selectedVisitsHistoryPeriod = this.visitsHistoryPeriodOptions[0];
    this.refreshVisitsList();
  }

  initOffers(statusChanged, offerType) {

    statusChanged = this.statusHasChangedBar || this.statusHasChangedRestaurant;
    if (statusChanged) {
      offerType = this.statusHasChangedRestaurant && this.statusHasChangedBar ? 'Restaurant & Bar' : (this.statusHasChangedRestaurant ? 'Restaurant' : 'Bar');
    }

    if (!statusChanged && this.offersInitiatedOnceRestaurant && this.offersInitiatedOnceBar && !this.venueTypeChanged) {
      return;
    }

    if (!statusChanged) {
      if (!this.venue.offers || this.venue.offers.length === 0 || this.venueTypeChanged) {

        if (this.venueTypeChanged) {

          if (this.hasRestaurant) {

            if (!this.venue.offers.find(x => x.type === 'Restaurant')) {
              const offers = VenueDetailsOffer.GetNewOffers('Restaurant');

              this.restaurantOffers = new Array();
              for (const offer of offers) {
                this.restaurantOffers.push(Object.assign({}, offer));
                this.venue.offers.push(Object.assign({}, offer));
              }
            }

            if (!this.hasBar && this.venue.offers.find(x => x.type === 'Bar')) {
              this.barOffers = new Array();

              for (let i = 0; i < this.venue.offers.length; i++) {
                if (this.venue.offers[i].type === 'Bar') {
                  this.venue.offers.splice(i--, 1);
                }
              }
            }
          }

          if (this.hasBar) {


            if (!this.venue.offers.find(x => x.type === 'Bar')) {
              const offers = VenueDetailsOffer.GetNewOffers('Bar');

              this.barOffers = new Array();
              for (const offer of offers) {
                this.barOffers.push(Object.assign({}, offer));
                this.venue.offers.push(Object.assign({}, offer));
              }
            }

            if (!this.hasRestaurant && this.venue.offers.find(x => x.type === 'Restaurant')) {
              this.restaurantOffers = new Array();

              for (let i = 0; i < this.venue.offers.length; i++) {
                if (this.venue.offers[i].type === 'Restaurant') {
                  this.venue.offers.splice(i--, 1);
                }
              }
            }
          }


        } else {


          this.venue.offers = new Array();

          if (this.hasRestaurant) {
            const offers = VenueDetailsOffer.GetNewOffers('Restaurant');

            this.restaurantOffers = new Array();
            for (const offer of offers) {
              this.restaurantOffers.push(Object.assign({}, offer));
              this.venue.offers.push(Object.assign({}, offer));
            }
          }
          if (this.hasBar) {
            const offers = VenueDetailsOffer.GetNewOffers('Bar');
            this.barOffers = new Array();
            for (const offer of offers) {
              this.barOffers.push(Object.assign({}, offer));
              this.venue.offers.push(Object.assign({}, offer));
            }
          }


        }


      } else {
        this.restaurantOffers = new Array();
        this.barOffers = new Array();
        for (const offer of this.venue.offers) {
          if (offer.type === 'Restaurant') {
            this.restaurantOffers.push(Object.assign({}, offer));
          } else {
            this.barOffers.push(Object.assign({}, offer));
          }
        }

        if (this.hasBar && this.hasRestaurant && this.venue.offers.length < 14) {
          if (this.restaurantOffers.length === 0) {
            const offers = VenueDetailsOffer.GetNewOffers('Restaurant');

            for (const offer of offers) {
              this.restaurantOffers.push(Object.assign({}, offer));
              this.venue.offers.push(Object.assign({}, offer));
            }
          }

          if (this.barOffers.length === 0) {
            const offers = VenueDetailsOffer.GetNewOffers('Bar');

            for (const offer of offers) {
              this.barOffers.push(Object.assign({}, offer));
              this.venue.offers.push(Object.assign({}, offer));
            }
          }
        }
      }
    } else {
      if (this.statusHasChangedRestaurant) {
        this.offerOptionsRestaurant = null;
        this.maxPartySizeOptionsRestaurant = null;
      }
      if (this.statusHasChangedBar) {
        this.maxPartySizeOptionsBar = null;
        this.offerOptionsBar = null;
      }
    }

    if (!this.maxPartySizeOptionsBar && (!offerType || offerType === 'Bar' || offerType === 'Restaurant & Bar')) {
      this.maxPartySizeOptionsBar = new Array();
      this.maxPartySizeOptionsBar.push(new EnumModel('1', '1'));
      this.maxPartySizeOptionsBar.push(new EnumModel('2', '2'));
      this.maxPartySizeOptionsBar.push(new EnumModel('3', '3'));
      this.maxPartySizeOptionsBar.push(new EnumModel('4', '4'));
      this.maxPartySizeOptionsBar.push(new EnumModel('5', '5'));
      this.maxPartySizeOptionsBar.push(new EnumModel('6', '6'));
      this.maxPartySizeOptionsBar.push(new EnumModel('7', '7'));
      this.maxPartySizeOptionsBar.push(new EnumModel('8', '8'));
      this.maxPartySizeOptionsBar.push(new EnumModel('9', '9'));
      this.maxPartySizeOptionsBar.push(new EnumModel('10', '10'));
      this.maxPartySizeOptionsBar.push(new EnumModel('11', '11'));
      this.maxPartySizeOptionsBar.push(new EnumModel('12', '12'));
      this.maxPartySizeOptionsBar.push(new EnumModel('13', '13'));
      this.maxPartySizeOptionsBar.push(new EnumModel('14', '14'));
      this.maxPartySizeOptionsBar.push(new EnumModel('15', '15'));
      this.maxPartySizeOptionsBar.push(new EnumModel('16', '16'));
      this.maxPartySizeOptionsBar.push(new EnumModel('17', '17'));
      this.maxPartySizeOptionsBar.push(new EnumModel('18', '18'));
      this.maxPartySizeOptionsBar.push(new EnumModel('19', '19'));
      this.maxPartySizeOptionsBar.push(new EnumModel('20', '20'));
    }

    if (!this.maxPartySizeOptionsRestaurant && (!offerType || offerType === 'Restaurant' || offerType === 'Restaurant & Bar')) {
      this.maxPartySizeOptionsRestaurant = new Array();
      this.maxPartySizeOptionsRestaurant.push(new EnumModel('1', '1'));
      this.maxPartySizeOptionsRestaurant.push(new EnumModel('2', '2'));
      this.maxPartySizeOptionsRestaurant.push(new EnumModel('3', '3'));
      this.maxPartySizeOptionsRestaurant.push(new EnumModel('4', '4'));
      this.maxPartySizeOptionsRestaurant.push(new EnumModel('5', '5'));
      this.maxPartySizeOptionsRestaurant.push(new EnumModel('6', '6'));
      this.maxPartySizeOptionsRestaurant.push(new EnumModel('7', '7'));
      this.maxPartySizeOptionsRestaurant.push(new EnumModel('8', '8'));
      this.maxPartySizeOptionsRestaurant.push(new EnumModel('9', '9'));
      this.maxPartySizeOptionsRestaurant.push(new EnumModel('10', '10'));
      this.maxPartySizeOptionsRestaurant.push(new EnumModel('11', '11'));
      this.maxPartySizeOptionsRestaurant.push(new EnumModel('12', '12'));
      this.maxPartySizeOptionsRestaurant.push(new EnumModel('13', '13'));
      this.maxPartySizeOptionsRestaurant.push(new EnumModel('14', '14'));
      this.maxPartySizeOptionsRestaurant.push(new EnumModel('15', '15'));
      this.maxPartySizeOptionsRestaurant.push(new EnumModel('16', '16'));
      this.maxPartySizeOptionsRestaurant.push(new EnumModel('17', '17'));
      this.maxPartySizeOptionsRestaurant.push(new EnumModel('18', '18'));
      this.maxPartySizeOptionsRestaurant.push(new EnumModel('19', '19'));
      this.maxPartySizeOptionsRestaurant.push(new EnumModel('20', '20'));
    }
    if (!this.offerOptionsBar && (!offerType || offerType === 'Bar' || offerType === 'Restaurant & Bar')) {
      this.offerOptionsBar = new Array();
      this.offerOptionsBar.push(new EnumModel('drink', 'Drinks'));
      this.offerOptionsBar.push(new EnumModel('total', 'Total Bill'));
    }
    if (!this.offerOptionsRestaurant && (!offerType || offerType === 'Restaurant' || offerType === 'Restaurant & Bar')) {
      this.offerOptionsRestaurant = new Array();
      this.offerOptionsRestaurant.push(new EnumModel('food', 'Food'));
      this.offerOptionsRestaurant.push(new EnumModel('total', 'Total Bill'));
    }

    if (!offerType) {
      this.oldOffersRestaurant = new Array<VenueDetailsOffer>();
      this.oldOffersBar = new Array<VenueDetailsOffer>();
    } else if (offerType === 'Restaurant & Bar') {
      this.oldOffersRestaurant = new Array<VenueDetailsOffer>();
      this.oldOffersBar = new Array<VenueDetailsOffer>();
    } else if (offerType === 'Restaurant') {
      this.oldOffersRestaurant = new Array<VenueDetailsOffer>();
    } else {
      this.oldOffersBar = new Array<VenueDetailsOffer>();
    }

    for (const offer of this.restaurantOffers) {

      if (this.oldOffersRestaurant.length < 7) {
        this.oldOffersRestaurant.push(Object.assign({}, offer));
      }

      if (offer.pendingTotalBillTime !== null && this.offerOptionsRestaurant.length < 3 && (this.selectedRestaurantStatus && (this.selectedRestaurantStatus.id !== 'NotLive' && this.venue.id))) {
        if (!offer.pendingTotalBill) {
          this.offerOptionsRestaurant.push(new EnumModel('decrease', 'Total Bill &rarr; Food'));
        } else {
          this.offerOptionsRestaurant.push(new EnumModel('increase', 'Food &rarr; Total Bill'));
        }

      }


      if (offer.pendingMaxPartySizeTime && !this.maxPartySizeOptionsRestaurant.find(x => x.id === 'increase' || x.id === 'decrease') && (this.selectedRestaurantStatus && (this.selectedRestaurantStatus.id !== 'NotLive' && this.venue.id))) {
        if (offer.pendingMaxPartySize < offer.maxPartySize) {
          this.maxPartySizeOptionsRestaurant.push(new EnumModel('decrease', offer.maxPartySize.toString() + ' &rarr; ' + offer.pendingMaxPartySize.toString()));
        } else {
          this.maxPartySizeOptionsRestaurant.push(new EnumModel('increase', offer.maxPartySize.toString() + ' &rarr; ' + offer.pendingMaxPartySize.toString()));
        }

      }

      this.selectedMaxPartySizeRestaurant = offer.pendingMaxPartySizeTime && (this.selectedRestaurantStatus && (this.selectedRestaurantStatus.id !== 'NotLive' && this.venue.id))
        ? EnumModel.GetByIdOrFirst(this.maxPartySizeOptionsRestaurant, this.maxPartySizeOptionsRestaurant.find(x => x.id === 'increase' || x.id === 'decrease').id)
        : EnumModel.GetByIdOrFirst(this.maxPartySizeOptionsRestaurant, offer.maxPartySize ? offer.maxPartySize.toString() : null);
      if (offer.pendingTotalBillTime && (this.selectedRestaurantStatus && (this.selectedRestaurantStatus.id !== 'NotLive' && this.venue.id))) {
        this.selectedOfferOptionRestaurant = this.offerOptionsRestaurant[2]; //  Total Bill
      } else if (offer.totalBill) {
        this.selectedOfferOptionRestaurant = this.offerOptionsRestaurant[1]; //  Total Bill
      } else {
        this.selectedOfferOptionRestaurant = this.offerOptionsRestaurant[0]; // Drink
      }

      if (statusChanged) {
        offer.pendingIsLive = null;
        offer.pendingPerk = null
        this.updateOfferIsLive(offer, 'initial', false);
        this.updateOfferLunch(offer, 'initial', false);
        this.updateOfferDinner(offer, 'initial', false);
        this.updateOfferAfterNine(offer, 'initial', false);
        this.updateOfferBeforeNine(offer, 'initial', false);
        this.updateOfferPerk(offer, 'initial');

      } else {
        this.updateOfferIsLive(offer, null, false);
        this.updateOfferLunch(offer, null, false);
        this.updateOfferDinner(offer, null, false);
        this.updateOfferAfterNine(offer, null, false);
        this.updateOfferBeforeNine(offer, null, false);
        this.updateOfferPerk(offer, null);
      }

    }

    for (const offer of this.barOffers) {

      if (this.oldOffersBar.length < 7) {
        this.oldOffersBar.push(Object.assign({}, offer));
      }

      if (offer.pendingTotalBillTime !== null && this.offerOptionsBar.length < 3 && (this.selectedBarStatus && (this.selectedBarStatus.id !== 'NotLive' && this.venue.id))) {
        if (!offer.pendingTotalBill) {
          this.offerOptionsBar.push(new EnumModel('decrease', 'Total Bill &rarr; Drinks'));
        } else {
          this.offerOptionsBar.push(new EnumModel('increase', 'Drinks &rarr; Total Bill'));
        }

      }


      if (offer.pendingMaxPartySizeTime && !this.maxPartySizeOptionsBar.find(x => x.id === 'increase' || x.id === 'decrease') && (this.selectedBarStatus && (this.selectedBarStatus.id !== 'NotLive' && this.venue.id))) {
        if (offer.pendingMaxPartySize < offer.maxPartySize) {
          this.maxPartySizeOptionsBar.push(new EnumModel('decrease', offer.maxPartySize.toString() + ' &rarr; ' + offer.pendingMaxPartySize.toString()));
        } else {
          this.maxPartySizeOptionsBar.push(new EnumModel('increase', offer.maxPartySize.toString() + ' &rarr; ' + offer.pendingMaxPartySize.toString()));
        }

      }

      this.selectedMaxPartySizeBar = offer.pendingMaxPartySizeTime && (this.selectedBarStatus && (this.selectedBarStatus.id !== 'NotLive' && this.venue.id))
        ? EnumModel.GetByIdOrFirst(this.maxPartySizeOptionsBar, this.maxPartySizeOptionsBar.find(x => x.id === 'increase' || x.id === 'decrease').id)
        : EnumModel.GetByIdOrFirst(this.maxPartySizeOptionsBar, offer.maxPartySize ? offer.maxPartySize.toString() : null);
      if (offer.pendingTotalBillTime && (this.selectedBarStatus && (this.selectedBarStatus.id !== 'NotLive' && this.venue.id))) {
        this.selectedOfferOptionBar = this.offerOptionsBar[2]; //  Total Bill
      } else if (offer.totalBill) {
        this.selectedOfferOptionBar = this.offerOptionsBar[1]; //  Total Bill
      } else {
        this.selectedOfferOptionBar = this.offerOptionsBar[0]; // Drink
      }

      if (statusChanged) {
        offer.pendingIsLive = null;
        offer.pendingPerk = null;
        this.updateOfferIsLive(offer, 'initial', false);
        this.updateOfferLunch(offer, 'initial', false);
        this.updateOfferDinner(offer, 'initial', false);
        this.updateOfferAfterNine(offer, 'initial', false);
        this.updateOfferBeforeNine(offer, 'initial', false);
        this.updateOfferPerk(offer, 'initial');
      } else {
        this.updateOfferIsLive(offer, null, false);
        this.updateOfferLunch(offer, null, false);
        this.updateOfferDinner(offer, null, false);
        this.updateOfferAfterNine(offer, null, false);
        this.updateOfferBeforeNine(offer, null, false);
        this.updateOfferPerk(offer, null);
      }

    }


    if (this.offerOptionsBar && this.offerOptionsBar.length === 3) {
      this.selectedOfferOptionBar = this.offerOptionsBar[2];
    }

    if (this.maxPartySizeOptionsBar && this.maxPartySizeOptionsBar.find(x => x.id === 'increase' || x.id === 'decrease')) {
      this.selectedMaxPartySizeBar = this.maxPartySizeOptionsBar.find(x => x.id === 'increase' || x.id === 'decrease');
    }

    if (this.offerOptionsRestaurant && this.offerOptionsRestaurant.length === 3) {
      this.selectedOfferOptionRestaurant = this.offerOptionsRestaurant[2];
    }

    if (this.maxPartySizeOptionsRestaurant && this.maxPartySizeOptionsRestaurant.find(x => x.id === 'increase' || x.id === 'decrease')) {
      this.selectedMaxPartySizeRestaurant = this.maxPartySizeOptionsRestaurant.find(x => x.id === 'increase' || x.id === 'decrease');
    }

    this.statusHasChangedRestaurant = false;
    this.statusHasChangedBar = false;

    if (this.hasRestaurant) {
      this.offersInitiatedOnceRestaurant = true;
    }
    if (this.hasBar) {
      this.offersInitiatedOnceBar = true;
    }

    for (const offer of this.oldOffersRestaurant) {

      for (const compareOffer of this.oldOffersRestaurant) {
        if (offer.totalBill !== compareOffer.totalBill && this.selectedRestaurantStatus.id !== 'NotLive') {
          this.disableOfferTypeRestaurant = true;
        }
        if (offer.maxPartySize !== compareOffer.maxPartySize && this.selectedRestaurantStatus.id !== 'NotLive') {
          this.disableMaxPartySizeRestaurant = true;
        }
      }

    }

    for (const offer of this.oldOffersBar) {

      for (const compareOffer of this.oldOffersBar) {
        if (offer.totalBill !== compareOffer.totalBill && this.selectedBarStatus.id !== 'NotLive') {
          this.disableOfferTypeBar = true;
        }
        if (offer.maxPartySize !== compareOffer.maxPartySize && this.selectedBarStatus.id !== 'NotLive') {
          this.disableMaxPartySizeBar = true;
        }
      }

    }

  }


  switchOfferDetailsType(type) {
    this.activeDetailsType = type;

    if (this.offerOptionsBar) {
      if (!this.initialLoadBar || this.offerOptionsBar.length === 3) {
        this.updateBarOfferDetails();
      }
    }
    if (this.maxPartySizeOptionsBar) {
      if (!this.initialLoadBar || this.maxPartySizeOptionsBar.find(x => x.id === 'increase' || x.id === 'decrease')) {
        this.updateBarMaxPartySize();
      }
    }

    if (this.offerOptionsRestaurant) {
      if (!this.initialLoadRestaurant || this.offerOptionsRestaurant.length === 3) {
        this.updateRestaurantOfferDetails();
      }
    }
    if (this.maxPartySizeOptionsRestaurant) {
      if (!this.initialLoadRestaurant || this.maxPartySizeOptionsRestaurant.find(x => x.id === 'increase' || x.id === 'decrease')) {
        this.updateRestaurantMaxPartySize();
      }
    }
  }

  showOTFakeMessageRestaurant() {
    if (!this.selectedOfferOptionRestaurant) {
      this.showOTFakeValueRestaurant = false;
      return;
    }

    this.fakeOfferTypeRestaurantMessage = this.selectedOfferOptionRestaurant.id === 'increase' || this.selectedOfferOptionRestaurant.id === 'decrease'
      ? this.selectedOfferOptionRestaurant.name
      : (this.selectedRestaurantStatus.id !== 'NotLive' && this.venue.id)
        ? ((this.oldOffersRestaurant[0].totalBill
          ? (this.restaurantOffers[0].totalBill
            ? this.selectedOfferOptionRestaurant.name : 'Total Bill &rarr; Food')
          : (!this.restaurantOffers[0].totalBill
            ? this.selectedOfferOptionRestaurant.name : 'Food &rarr; Total Bill')))
        : this.selectedOfferOptionRestaurant.name;

    this.showOTFakeValueRestaurant = true;
  }

  showOTDropRestaurant() {
    this.showOTDropdownRestaurant = true;
  }

  showPSFakeMessageRestaurant() {
    if (!this.selectedMaxPartySizeRestaurant) {
      this.showPSFakeValueRestaurant = false;
      return;
    }

    this.fakeMaxPartySizeRestaurantMessage = this.selectedMaxPartySizeRestaurant.id === 'increase' || this.selectedMaxPartySizeRestaurant.id === 'decrease'
      ? this.selectedMaxPartySizeRestaurant.name
      : (this.selectedRestaurantStatus.id !== 'NotLive' && this.venue.id)
        ? ((this.oldOffersRestaurant[0].maxPartySize !== this.restaurantOffers[0].maxPartySize
          ? (this.oldOffersRestaurant[0].maxPartySize.toString() + ' &rarr; ' + this.restaurantOffers[0].maxPartySize.toString())
          : this.restaurantOffers[0].maxPartySize.toString()))
        : this.selectedMaxPartySizeRestaurant.name;

    this.showPSFakeValueRestaurant = true;
  }

  showPSDropRestaurant() {
    this.showPSDropdownRestaurant = true;
  }

  showOTFakeMessageBar() {
    if (!this.selectedOfferOptionBar) {
      this.showOTFakeValueBar = false;
      return;
    }

    this.fakeOfferTypeBarMessage = this.selectedOfferOptionBar.id === 'increase' || this.selectedOfferOptionBar.id === 'decrease'
      ? this.selectedOfferOptionBar.name
      : (this.selectedBarStatus.id !== 'NotLive' && this.venue.id)
        ? ((this.oldOffersBar[0].totalBill
          ? (this.barOffers[0].totalBill
            ? this.selectedOfferOptionBar.name : 'Total Bill &rarr; Drinks')
          : (!this.barOffers[0].totalBill
            ? this.selectedOfferOptionBar.name : 'Drinks &rarr; Total Bill')))
        : this.selectedOfferOptionBar.name;

    this.showOTFakeValueBar = true;
  }

  showOTDropBar() {
    this.showOTDropdownBar = true;
  }

  showPSFakeMessageBar() {
    if (!this.selectedMaxPartySizeBar) {
      this.showPSFakeValueBar = false;
      return;
    }

    this.fakeMaxPartySizeBarMessage = this.selectedMaxPartySizeBar.id === 'increase' || this.selectedMaxPartySizeBar.id === 'decrease'
      ? this.selectedMaxPartySizeBar.name
      : (this.selectedBarStatus.id !== 'NotLive' && this.venue.id)
        ? ((this.oldOffersBar[0].maxPartySize !== this.barOffers[0].maxPartySize
          ? (this.oldOffersBar[0].maxPartySize.toString() + ' &rarr; ' + this.barOffers[0].maxPartySize.toString())
          : this.barOffers[0].maxPartySize.toString()))
        : this.selectedMaxPartySizeBar.name;

    this.showPSFakeValueBar = true;
  }

  showPSDropBar() {
    this.showPSDropdownBar = true;
  }

  updateRestaurantOfferDetails() {

    let date = null;

    for (const offer of this.restaurantOffers) {
      if (offer.type !== 'Bar') {
        offer.totalBill = this.selectedOfferOptionRestaurant.id === 'total';

        const oldOffer = this.oldOffersRestaurant.find(x => x.type === 'Restaurant' && x.day === offer.day);

        if (this.selectedOfferOptionRestaurant.id !== 'increase' && this.selectedOfferOptionRestaurant.id !== 'decrease' && !this.offerOptionsRestaurantDirty) {
          this.offerTypeChangeRestaurantLabel = '';
          return;
        }

        if (oldOffer.pendingTotalBillTime) {

          date = new Date(Math.max.apply(null, this.oldOffersRestaurant.map(function (off) {
            const fullDate = new Date(off.pendingTotalBillTime);
            return new Date(fullDate.getUTCFullYear(), fullDate.getUTCMonth(), fullDate.getUTCDate(), fullDate.getUTCHours(), fullDate.getUTCMinutes(), fullDate.getUTCSeconds());
          })));

          // const fullDate = new Date(oldOffer.pendingTotalBillTime);
          // date = new Date(fullDate.getUTCFullYear(), fullDate.getUTCMonth(), fullDate.getUTCDate(), fullDate.getUTCHours(), fullDate.getUTCMinutes(), fullDate.getUTCSeconds());
        }


        if (this.selectedOfferOptionRestaurant.id === 'increase' || this.selectedOfferOptionRestaurant.id === 'decrease') {
          this.offerTypeChangeRestaurantLabel = (this.selectedRestaurantStatus.id !== 'NotLive' && this.venue.id)
            ? (this.selectedOfferOptionRestaurant.id === 'increase'
              ? 'Level will increase from ' + new DatePipe('en-US').transform(oldOffer.pendingTotalBillTime, 'shortTime')
              : 'Level will decrease from ' + new DatePipe('en-GB').transform(date, 'EEEE d'))
            : '';
        } else {
          this.offerTypeChangeRestaurantLabel = (this.selectedRestaurantStatus.id !== 'NotLive' && this.venue.id)
            ? oldOffer.totalBill === offer.totalBill ? (!date ? '' : 'Level will remain the same') : (offer.totalBill ? 'Level will increase in 1 hr' : 'Level will decrease from ' + this.getDateLabel7Days())
            : '';
          if (oldOffer.totalBill === offer.totalBill && !oldOffer.pendingTotalBill) {
            this.offerTypeChangeRestaurantLabel = (this.selectedRestaurantStatus.id !== 'NotLive' && this.venue.id) ? (!date ? '' : 'Level will remain the same') : '';
          }
        }

        if (this.offerTypeChangeRestaurantLabel.endsWith('1') && !this.offerTypeChangeRestaurantLabel.endsWith(' 11')) this.offerTypeChangeRestaurantLabel += 'st ' + new DatePipe('en-GB').transform(date, 'MMMM');
        else if (this.offerTypeChangeRestaurantLabel.endsWith('2') && !this.offerTypeChangeRestaurantLabel.endsWith(' 12')) this.offerTypeChangeRestaurantLabel += 'nd ' + new DatePipe('en-GB').transform(date, 'MMMM');
        else if (this.offerTypeChangeRestaurantLabel.endsWith('3') && !this.offerTypeChangeRestaurantLabel.endsWith(' 13')) this.offerTypeChangeRestaurantLabel += 'rd ' + new DatePipe('en-GB').transform(date, 'MMMM');
        else if (this.offerTypeChangeRestaurantLabel.endsWith('1') || this.offerTypeChangeRestaurantLabel.endsWith('2') || this.offerTypeChangeRestaurantLabel.endsWith('3') || this.offerTypeChangeRestaurantLabel.endsWith('4') || this.offerTypeChangeRestaurantLabel.endsWith('5') || this.offerTypeChangeRestaurantLabel.endsWith('6')
          || this.offerTypeChangeRestaurantLabel.endsWith('7') || this.offerTypeChangeRestaurantLabel.endsWith('8') || this.offerTypeChangeRestaurantLabel.endsWith('9')
          || this.offerTypeChangeRestaurantLabel.endsWith('0')) this.offerTypeChangeRestaurantLabel += 'th ' + new DatePipe('en-GB').transform(date, 'MMMM');

        offer.pendingTotalBill = offer.totalBill;
      }
    }
  }


  updateOfferIsLive(offer, value, updateOthers) {

    let oldOffer = this.oldOffersRestaurant.find(x => x.type === offer.type && x.day === offer.day);

    if (!oldOffer) {
      oldOffer = this.oldOffersBar.find(x => x.type === offer.type && x.day === offer.day);
    }

    if (this.venue.id) {
      offer.isLive = oldOffer.isLive;
    }

    if (!value) {
      if (oldOffer.pendingIsLive === null) {
        offer.showInitialIsLive = true;
        offer.showPendingFalseIsLive = false;
        offer.showPendingTrueIsLive = false;
      } else if (oldOffer.pendingIsLive === false) {
        offer.showInitialIsLive = false;
        offer.showPendingFalseIsLive = true;
        offer.showPendingTrueIsLive = false;
        offer.displayIsLive = true;
      } else {
        offer.showInitialIsLive = false;
        offer.showPendingFalseIsLive = false;
        offer.showPendingTrueIsLive = true;
        offer.displayIsLive = false;
      }
    } else {
      if (value === 'initial') {
        offer.showInitialIsLive = true;
        offer.showPendingFalseIsLive = false;
        offer.showPendingTrueIsLive = false;
      } else if (value === 'pendingFalse') {
        offer.showInitialIsLive = false;
        offer.showPendingFalseIsLive = true;
        offer.showPendingTrueIsLive = false;
        offer.displayIsLive = true;
      } else {
        offer.showInitialIsLive = false;
        offer.showPendingFalseIsLive = false;
        offer.showPendingTrueIsLive = true;
        offer.displayIsLive = false;
      }
    }

    if (!offer.isLiveDirty && oldOffer.pendingIsLive == null) {
      offer.isLiveLabel = '';
      return;
    }

    let date = null;
    if (oldOffer.pendingIsLiveTime) {
      const fullDate = new Date(oldOffer.pendingIsLiveTime);
      date = new Date(fullDate.getUTCFullYear(), fullDate.getUTCMonth(), fullDate.getUTCDate(), fullDate.getUTCHours(), fullDate.getUTCMinutes(), fullDate.getUTCSeconds());
    }

    const status = offer.type === 'Bar' ? this.selectedBarStatus.id : this.selectedRestaurantStatus.id;

    if (oldOffer.pendingIsLive !== null && !offer.isLiveDirty) {
      offer.isLiveLabel = (status !== 'NotLive' && this.venue.id)
        ? (offer.showPendingTrueIsLive
          ? offer.day + ' will be added from ' + new DatePipe('en-US').transform(oldOffer.pendingIsLiveTime, 'shortTime')
          : (offer.showPendingFalseIsLive ? offer.day + ' will be removed from ' + new DatePipe('en-GB').transform(date, 'EEEE d') : offer.day + ' will remain the same'))
        : '';

    } else {
      offer.isLiveLabel = (status !== 'NotLive' && this.venue.id)
        ? (offer.showPendingTrueIsLive ? offer.day + ' will be added in 1 hr' : (offer.showPendingFalseIsLive ? offer.day + ' will be removed from ' + this.getDateLabel(offer) : (!date ? '' : offer.day + ' will remain the same')))
        : '';

    }

    if (offer.isLiveLabel.endsWith('1') && !offer.isLiveLabel.endsWith(' 11')) offer.isLiveLabel += 'st ' + new DatePipe('en-GB').transform(date, 'MMMM');
    else if (offer.isLiveLabel.endsWith('2') && !offer.isLiveLabel.endsWith(' 12')) offer.isLiveLabel += 'nd ' + new DatePipe('en-GB').transform(date, 'MMMM');
    else if (offer.isLiveLabel.endsWith('3') && !offer.isLiveLabel.endsWith(' 13')) offer.isLiveLabel += 'rd ' + new DatePipe('en-GB').transform(date, 'MMMM');
    else if (offer.isLiveLabel.endsWith('1') || offer.isLiveLabel.endsWith('2') || offer.isLiveLabel.endsWith('3') || offer.isLiveLabel.endsWith('4') || offer.isLiveLabel.endsWith('5') || offer.isLiveLabel.endsWith('6')
      || offer.isLiveLabel.endsWith('7') || offer.isLiveLabel.endsWith('8') || offer.isLiveLabel.endsWith('9')
      || offer.isLiveLabel.endsWith('0')) offer.isLiveLabel += 'th ' + new DatePipe('en-GB').transform(date, 'MMMM');

    if (updateOthers) {
      if ((offer.day === 'Friday' || offer.day === 'Saturday' || offer.day === 'Sunday') && offer.type === 'Restaurant' && offer.isLiveDirty) {
        offer.lunchDirty = true;
        offer.dinnerDirty = true;
        offer.perkDirty = true;
        this.updateOfferLunch(offer, value, false);
        this.updateOfferDinner(offer, value, false);
        this.updateOfferPerk(offer, value);
      }

      if ((offer.day === 'Friday' || offer.day === 'Saturday' || offer.day === 'Sunday') && offer.type === 'Bar' && offer.isLiveDirty) {
        offer.afterNineDirty = true;
        offer.beforeNineDirty = true;
        offer.perkDirty = true;
        this.updateOfferAfterNine(offer, value, false);
        this.updateOfferBeforeNine(offer, value, false);
        this.updateOfferPerk(offer, value);
      }

      if (offer.day !== 'Friday' && offer.day !== 'Saturday' && offer.day !== 'Sunday') {
        offer.perkDirty = true;
        this.updateOfferPerk(offer, value);

      }

    }
  }

  updateOfferPerk(offer, perkState) {

    const oldOffer = [...this.oldOffersRestaurant, ...this.oldOffersBar]
      .find(x => x.type === offer.type && x.day === offer.day);

    if (oldOffer && this.venue.id) {
      offer.perk = oldOffer.perk;
    }

    const resetPerkDisplay = () => {
      offer.showInitialPerk = false;
      offer.showPendingFalsePerk = false;
      offer.showPendingTruePerk = false;
      offer.displayPerk = false;
    };

    if (!perkState) {
      // no perkState , use the oldOffer perkState
      if (oldOffer.pendingPerk === null) {
        offer.showInitialPerk = true;
      } else if (oldOffer.pendingPerk === false) {
        offer.showPendingFalsePerk = true;
        offer.displayPerk = true;
      } else {
        offer.showPendingTruePerk = true;
      }
    } else {
      //  use the perkState 
      resetPerkDisplay();
      if (perkState === 'initial') {
        offer.showInitialPerk = true;
      } else if (perkState === 'pendingFalse') {
        offer.showPendingFalsePerk = true;
        offer.displayPerk = true;
      } else {
        offer.showPendingTruePerk = true;
      }
    }

    if (!offer.perkDirty && oldOffer.pendingPerk == null) {
      offer.perkLabel = '';
      return;
    }

    let date = oldOffer.pendingPerkTime ? convertToUTCDate(oldOffer.pendingPerkTime) : null;

    const status = offer.type === 'Bar' ? this.selectedBarStatus.id : this.selectedRestaurantStatus.id;

    if (oldOffer.pendingPerk !== null && !offer.perkDirty) {
      offer.perkLabel = (status !== 'NotLive' && this.venue.id)
        ? (offer.showPendingTruePerk
          ? this.perkLabelText + ' ' + StatusChange.WillBeAddedFrom + new DatePipe('en-US').transform(oldOffer.pendingPerkTime, 'shortTime')
          : (offer.showPendingFalsePerk ? this.perkLabelText + ' ' + StatusChange.WillBeRemovedFrom + new DatePipe('en-GB').transform(date, 'EEEE d') : this.perkLabelText + ' ' + StatusChange.WillRemainTheSame))
        : '';
    } else {
      offer.perkLabel = (status !== 'NotLive' && this.venue.id)
        ? (offer.showPendingTruePerk ? this.perkLabelText + ' ' + StatusChange.WillBeAdded1Hr : (offer.showPendingFalsePerk ? this.perkLabelText + ' ' + StatusChange.WillBeRemovedFrom + this.getDateLabel(offer) : (!date ? '' : this.perkLabelText + ' ' + StatusChange.WillRemainTheSame)))
        : '';
    }

    offer.perkLabel = appendDateWithSuffix(offer, date);
  }

  updateOfferLunch(offer, value, updateOthers) {

    let oldOffer = this.oldOffersRestaurant.find(x => x.type === offer.type && x.day === offer.day);

    if (!oldOffer) {
      oldOffer = this.oldOffersBar.find(x => x.type === offer.type && x.day === offer.day);
    }
    if (this.venue.id) {
      offer.lunch = oldOffer.lunch;
    } else {
      if (!updateOthers) {
        offer.lunch = offer.isLive;
      }
    }

    if (!value) {
      if (oldOffer.pendingLunch === null) {
        offer.showInitialLunch = true;
        offer.showPendingFalseLunch = false;
        offer.showPendingTrueLunch = false;
      } else if (oldOffer.pendingLunch === false) {
        offer.showInitialLunch = false;
        offer.showPendingFalseLunch = true;
        offer.showPendingTrueLunch = false;
        offer.displayLunch = true;
      } else {
        offer.showInitialLunch = false;
        offer.showPendingFalseLunch = false;
        offer.showPendingTrueLunch = true;
        offer.displayLunch = false;
      }
    } else {
      if (value === 'initial') {
        offer.showInitialLunch = true;
        offer.showPendingFalseLunch = false;
        offer.showPendingTrueLunch = false;
      } else if (value === 'pendingFalse') {
        offer.showInitialLunch = false;
        offer.showPendingFalseLunch = true;
        offer.showPendingTrueLunch = false;
        offer.displayLunch = true;
      } else {
        offer.showInitialLunch = false;
        offer.showPendingFalseLunch = false;
        offer.showPendingTrueLunch = true;
        offer.displayLunch = false;
      }
    }

    if (!offer.lunchDirty && oldOffer.pendingLunch == null) {
      offer.lunchLabel = '';
      return;
    }

    let date = null;
    if (oldOffer.pendingLunchTime) {
      const fullDate = new Date(oldOffer.pendingLunchTime);
      date = new Date(fullDate.getUTCFullYear(), fullDate.getUTCMonth(), fullDate.getUTCDate(), fullDate.getUTCHours(), fullDate.getUTCMinutes(), fullDate.getUTCSeconds());
    }


    if (oldOffer.pendingLunch !== null && !offer.lunchDirty) {
      offer.lunchLabel = (this.selectedRestaurantStatus.id !== 'NotLive' && this.venue.id)
        ? (offer.showPendingTrueLunch
          ? 'Lunch' + ' will be added from ' + new DatePipe('en-US').transform(oldOffer.pendingLunchTime, 'shortTime')
          : (offer.showPendingFalseLunch ? 'Lunch' + ' will be removed from ' + new DatePipe('en-GB').transform(date, 'EEEE d') : 'Lunch' + ' will remain the same'))
        : '';
    } else {
      offer.lunchLabel = (this.selectedRestaurantStatus.id !== 'NotLive' && this.venue.id)
        ? (offer.showPendingTrueLunch ? 'Lunch' + ' will be added in 1 hr' : (offer.showPendingFalseLunch ? 'Lunch' + ' will be removed from ' + this.getDateLabel(offer) : (!date ? '' : 'Lunch' + ' will remain the same')))
        : '';

    }

    if (offer.lunchLabel.endsWith('1') && !offer.lunchLabel.endsWith(' 11')) offer.lunchLabel += 'st ' + new DatePipe('en-GB').transform(date, 'MMMM');
    else if (offer.lunchLabel.endsWith('2') && !offer.lunchLabel.endsWith(' 12')) offer.lunchLabel += 'nd ' + new DatePipe('en-GB').transform(date, 'MMMM');
    else if (offer.lunchLabel.endsWith('3') && !offer.lunchLabel.endsWith(' 13')) offer.lunchLabel += 'rd ' + new DatePipe('en-GB').transform(date, 'MMMM');
    else if (offer.lunchLabel.endsWith('1') || offer.lunchLabel.endsWith('2') || offer.lunchLabel.endsWith('3') || offer.lunchLabel.endsWith('4') || offer.lunchLabel.endsWith('5') || offer.lunchLabel.endsWith('6')
      || offer.lunchLabel.endsWith('7') || offer.lunchLabel.endsWith('8') || offer.lunchLabel.endsWith('9')
      || offer.lunchLabel.endsWith('0')) offer.lunchLabel += 'th ' + new DatePipe('en-GB').transform(date, 'MMMM');

    if (updateOthers) {
      if ((offer.day === 'Friday' || offer.day === 'Saturday' || offer.day === 'Sunday') && offer.type === 'Restaurant' && (offer.lunchDirty || offer.dinnerDirty)) {
        if ((!(!offer.lunch && offer.showPendingTrueLunch) && !(offer.lunch && !offer.showPendingFalseLunch))
          && (!(!offer.dinner && offer.showPendingTrueDinner) && !(offer.dinner && !offer.showPendingFalseDinner))
          && (offer.isLive || offer.showPendingTrueIsLive)) {

          offer.isLiveDirty = true;
          offer.perk = false;
          this.updateOfferPerk(offer, offer.isLive ? 'pendingFalse' : 'initial');
          this.updateOfferIsLive(offer, offer.isLive ? 'pendingFalse' : 'initial', false);
        }
      }
    }

  }

  updateOfferDinner(offer, value, updateOthers) {

    let oldOffer = this.oldOffersRestaurant.find(x => x.type === offer.type && x.day === offer.day);

    if (!oldOffer) {
      oldOffer = this.oldOffersBar.find(x => x.type === offer.type && x.day === offer.day);
    }
    if (this.venue.id) {
      offer.dinner = oldOffer.dinner;
    } else {
      if (!updateOthers) {
        offer.dinner = offer.isLive;
      }
    }

    if (!value) {
      if (oldOffer.pendingDinner === null) {
        offer.showInitialDinner = true;
        offer.showPendingFalseDinner = false;
        offer.showPendingTrueDinner = false;
      } else if (oldOffer.pendingDinner === false) {
        offer.showInitialDinner = false;
        offer.showPendingFalseDinner = true;
        offer.showPendingTrueDinner = false;
        offer.displayDinner = true;
      } else {
        offer.showInitialDinner = false;
        offer.showPendingFalseDinner = false;
        offer.showPendingTrueDinner = true;
        offer.displayDinner = false;
      }
    } else {
      if (value === 'initial') {
        offer.showInitialDinner = true;
        offer.showPendingFalseDinner = false;
        offer.showPendingTrueDinner = false;
      } else if (value === 'pendingFalse') {
        offer.showInitialDinner = false;
        offer.showPendingFalseDinner = true;
        offer.showPendingTrueDinner = false;
        offer.displayDinner = true;
      } else {
        offer.showInitialDinner = false;
        offer.showPendingFalseDinner = false;
        offer.showPendingTrueDinner = true;
        offer.displayDinner = false;
      }
    }

    if (!offer.dinnerDirty && oldOffer.pendingDinner == null) {
      offer.dinnerLabel = '';
      return;
    }

    let date = null;
    if (oldOffer.pendingDinnerTime) {
      const fullDate = new Date(oldOffer.pendingDinnerTime);
      date = new Date(fullDate.getUTCFullYear(), fullDate.getUTCMonth(), fullDate.getUTCDate(), fullDate.getUTCHours(), fullDate.getUTCMinutes(), fullDate.getUTCSeconds());
    }


    if (oldOffer.pendingDinner !== null && !offer.dinnerDirty) {
      offer.dinnerLabel = (this.selectedRestaurantStatus.id !== 'NotLive' && this.venue.id)
        ? (offer.showPendingTrueDinner
          ? 'Dinner' + ' will be added from ' + new DatePipe('en-US').transform(oldOffer.pendingDinnerTime, 'shortTime')
          : (offer.showPendingFalseDinner ? 'Dinner' + ' will be removed from ' + new DatePipe('en-GB').transform(date, 'EEEE d') : 'Dinner' + ' will remain the same'))
        : '';

    } else {
      offer.dinnerLabel = (this.selectedRestaurantStatus.id !== 'NotLive' && this.venue.id)
        ? (offer.showPendingTrueDinner ? 'Dinner' + ' will be added in 1 hr' : (offer.showPendingFalseDinner ? 'Dinner' + ' will be removed from ' + this.getDateLabel(offer) : (!date ? '' : 'Dinner' + ' will remain the same')))
        : '';

    }

    if (offer.dinnerLabel.endsWith('1') && !offer.dinnerLabel.endsWith(' 11')) offer.dinnerLabel += 'st ' + new DatePipe('en-GB').transform(date, 'MMMM');
    else if (offer.dinnerLabel.endsWith('2') && !offer.dinnerLabel.endsWith(' 12')) offer.dinnerLabel += 'nd ' + new DatePipe('en-GB').transform(date, 'MMMM');
    else if (offer.dinnerLabel.endsWith('3') && !offer.dinnerLabel.endsWith(' 13')) offer.dinnerLabel += 'rd ' + new DatePipe('en-GB').transform(date, 'MMMM');
    else if (offer.dinnerLabel.endsWith('1') || offer.dinnerLabel.endsWith('2') || offer.dinnerLabel.endsWith('3') || offer.dinnerLabel.endsWith('4') || offer.dinnerLabel.endsWith('5') || offer.dinnerLabel.endsWith('6')
      || offer.dinnerLabel.endsWith('7') || offer.dinnerLabel.endsWith('8') || offer.dinnerLabel.endsWith('9')
      || offer.dinnerLabel.endsWith('0')) offer.dinnerLabel += 'th ' + new DatePipe('en-GB').transform(date, 'MMMM');


    if (updateOthers) {
      if ((offer.day === 'Friday' || offer.day === 'Saturday' || offer.day === 'Sunday') && offer.type === 'Restaurant' && (offer.lunchDirty || offer.dinnerDirty)) {
        if ((!(!offer.lunch && offer.showPendingTrueLunch) && !(offer.lunch && !offer.showPendingFalseLunch))
          && (!(!offer.dinner && offer.showPendingTrueDinner) && !(offer.dinner && !offer.showPendingFalseDinner))
          && (offer.isLive || offer.showPendingTrueIsLive)) {

          offer.isLiveDirty = true;
          offer.perk = false;
          this.updateOfferPerk(offer, offer.isLive ? 'pendingFalse' : 'initial');
          this.updateOfferIsLive(offer, offer.isLive ? 'pendingFalse' : 'initial', false);
        }
      }
    }

  }

  updateOfferAfterNine(offer, value, updateOthers) {

    let oldOffer = this.oldOffersRestaurant.find(x => x.type === offer.type && x.day === offer.day);

    if (!oldOffer) {
      oldOffer = this.oldOffersBar.find(x => x.type === offer.type && x.day === offer.day);
    }
    if (this.venue.id) {
      offer.afterNine = oldOffer.afterNine;
    } else {
      if (!updateOthers) {
        offer.afterNine = offer.isLive;
      }
    }

    if (!value) {
      if (oldOffer.pendingAfterNine === null) {
        offer.showInitialAfterNine = true;
        offer.showPendingFalseAfterNine = false;
        offer.showPendingTrueAfterNine = false;
      } else if (oldOffer.pendingAfterNine === false) {
        offer.showInitialAfterNine = false;
        offer.showPendingFalseAfterNine = true;
        offer.showPendingTrueAfterNine = false;
        offer.displayAfterNine = true;
      } else {
        offer.showInitialAfterNine = false;
        offer.showPendingFalseAfterNine = false;
        offer.showPendingTrueAfterNine = true;
        offer.displayAfterNine = false;
      }
    } else {
      if (value === 'initial') {
        offer.showInitialAfterNine = true;
        offer.showPendingFalseAfterNine = false;
        offer.showPendingTrueAfterNine = false;
      } else if (value === 'pendingFalse') {
        offer.showInitialAfterNine = false;
        offer.showPendingFalseAfterNine = true;
        offer.showPendingTrueAfterNine = false;
        offer.displayAfterNine = true;
      } else {
        offer.showInitialAfterNine = false;
        offer.showPendingFalseAfterNine = false;
        offer.showPendingTrueAfterNine = true;
        offer.displayAfterNine = false;
      }
    }

    if (!offer.afterNineDirty && oldOffer.pendingAfterNine == null) {
      offer.afterNineLabel = '';
      return;
    }

    let date = null;
    if (oldOffer.pendingAfterNineTime) {
      const fullDate = new Date(oldOffer.pendingAfterNineTime);
      date = new Date(fullDate.getUTCFullYear(), fullDate.getUTCMonth(), fullDate.getUTCDate(), fullDate.getUTCHours(), fullDate.getUTCMinutes(), fullDate.getUTCSeconds());
    }

    if (oldOffer.pendingAfterNine !== null && !offer.afterNineDirty) {
      offer.afterNineLabel = (this.selectedBarStatus.id !== 'NotLive' && this.venue.id)
        ? (offer.showPendingTrueAfterNine
          ? 'After 9pm' + ' will be added from ' + new DatePipe('en-US').transform(oldOffer.pendingAfterNineTime, 'shortTime')
          : (offer.showPendingFalseAfterNine ? 'After 9pm' + ' will be removed from ' + new DatePipe('en-GB').transform(date, 'EEEE d') : 'After 9pm' + ' will remain the same'))
        : '';

    } else {
      offer.afterNineLabel = (this.selectedBarStatus.id !== 'NotLive' && this.venue.id)
        ? (offer.showPendingTrueAfterNine ? 'After 9pm' + ' will be added in 1 hr' : (offer.showPendingFalseAfterNine ? 'After 9pm' + ' will be removed from ' + this.getDateLabel(offer) : (!date ? '' : 'After 9pm' + ' will remain the same')))
        : '';

    }

    if (offer.afterNineLabel.endsWith('1') && !offer.afterNineLabel.endsWith(' 11')) offer.afterNineLabel += 'st ' + new DatePipe('en-GB').transform(date, 'MMMM');
    else if (offer.afterNineLabel.endsWith('2') && !offer.afterNineLabel.endsWith(' 12')) offer.afterNineLabel += 'nd ' + new DatePipe('en-GB').transform(date, 'MMMM');
    else if (offer.afterNineLabel.endsWith('3') && !offer.afterNineLabel.endsWith(' 13')) offer.afterNineLabel += 'rd ' + new DatePipe('en-GB').transform(date, 'MMMM');
    else if (offer.afterNineLabel.endsWith('1') || offer.afterNineLabel.endsWith('2') || offer.afterNineLabel.endsWith('3') || offer.afterNineLabel.endsWith('4') || offer.afterNineLabel.endsWith('5') || offer.afterNineLabel.endsWith('6')
      || offer.afterNineLabel.endsWith('7') || offer.afterNineLabel.endsWith('8') || offer.afterNineLabel.endsWith('9')
      || offer.afterNineLabel.endsWith('0')) offer.afterNineLabel += 'th ' + new DatePipe('en-GB').transform(date, 'MMMM');

    if (updateOthers) {
      if ((offer.day === 'Friday' || offer.day === 'Saturday' || offer.day === 'Sunday') && offer.type === 'Bar' && (offer.afterNineDirty || offer.beforeNineDirty)) {
        if ((!(!offer.afterNine && offer.showPendingTrueAfterNine) && !(offer.afterNine && !offer.showPendingFalseAfterNine))
          && (!(!offer.beforeNine && offer.showPendingTrueBeforeNine) && !(offer.beforeNine && !offer.showPendingFalseBeforeNine))
          && (offer.isLive || offer.showPendingTrueIsLive)) {

          offer.isLiveDirty = true;
          offer.perk = false;
          this.updateOfferPerk(offer, offer.isLive ? 'pendingFalse' : 'initial');
          this.updateOfferIsLive(offer, offer.isLive ? 'pendingFalse' : 'initial', false);
        }
      }
    }

  }

  updateOfferBeforeNine(offer, value, updateOthers) {

    let oldOffer = this.oldOffersRestaurant.find(x => x.type === offer.type && x.day === offer.day);

    if (!oldOffer) {
      oldOffer = this.oldOffersBar.find(x => x.type === offer.type && x.day === offer.day);
    }
    if (this.venue.id) {
      offer.beforeNine = oldOffer.beforeNine;
    } else {
      if (!updateOthers) {
        offer.beforeNine = offer.isLive;
      }
    }

    if (!value) {
      if (oldOffer.pendingBeforeNine === null) {
        offer.showInitialBeforeNine = true;
        offer.showPendingFalseBeforeNine = false;
        offer.showPendingTrueBeforeNine = false;
      } else if (oldOffer.pendingBeforeNine === false) {
        offer.showInitialBeforeNine = false;
        offer.showPendingFalseBeforeNine = true;
        offer.showPendingTrueBeforeNine = false;
        offer.displayBeforeNine = true;
      } else {
        offer.showInitialBeforeNine = false;
        offer.showPendingFalseBeforeNine = false;
        offer.showPendingTrueBeforeNine = true;
        offer.displayBeforeNine = false;
      }
    } else {
      if (value === 'initial') {
        offer.showInitialBeforeNine = true;
        offer.showPendingFalseBeforeNine = false;
        offer.showPendingTrueBeforeNine = false;
      } else if (value === 'pendingFalse') {
        offer.showInitialBeforeNine = false;
        offer.showPendingFalseBeforeNine = true;
        offer.showPendingTrueBeforeNine = false;
        offer.displayBeforeNine = true;
      } else {
        offer.showInitialBeforeNine = false;
        offer.showPendingFalseBeforeNine = false;
        offer.showPendingTrueBeforeNine = true;
        offer.displayBeforeNine = false;
      }
    }

    if (!offer.beforeNineDirty && oldOffer.pendingBeforeNine == null) {
      offer.beforeNineLabel = '';
      return;
    }

    let date = null;
    if (oldOffer.pendingBeforeNineTime) {
      const fullDate = new Date(oldOffer.pendingBeforeNineTime);
      date = new Date(fullDate.getUTCFullYear(), fullDate.getUTCMonth(), fullDate.getUTCDate(), fullDate.getUTCHours(), fullDate.getUTCMinutes(), fullDate.getUTCSeconds());
    }

    if (oldOffer.pendingBeforeNine !== null && !offer.beforeNineDirty) {
      offer.beforeNineLabel = (this.selectedBarStatus.id !== 'NotLive' && this.venue.id)
        ? (offer.showPendingTrueBeforeNine
          ? 'Before 9pm' + ' will be added from ' + new DatePipe('en-US').transform(oldOffer.pendingBeforeNineTime, 'shortTime')
          : (offer.showPendingFalseBeforeNine ? 'Before 9pm' + ' will be removed from ' + new DatePipe('en-GB').transform(date, 'EEEE d') : 'Before 9pm' + ' will remain the same'))
        : '';

    } else {
      offer.beforeNineLabel = (this.selectedBarStatus.id !== 'NotLive' && this.venue.id)
        ? (offer.showPendingTrueBeforeNine ? 'Before 9pm' + ' will be added in 1 hr' : (offer.showPendingFalseBeforeNine ? 'Before 9pm' + ' will be removed from ' + this.getDateLabel(offer) : (!date ? '' : 'Before 9pm' + ' will remain the same')))
        : '';

    }

    if (offer.beforeNineLabel.endsWith('1') && !offer.beforeNineLabel.endsWith(' 11')) offer.beforeNineLabel += 'st ' + new DatePipe('en-GB').transform(date, 'MMMM');
    else if (offer.beforeNineLabel.endsWith('2') && !offer.beforeNineLabel.endsWith(' 12')) offer.beforeNineLabel += 'nd ' + new DatePipe('en-GB').transform(date, 'MMMM');
    else if (offer.beforeNineLabel.endsWith('3') && !offer.beforeNineLabel.endsWith(' 13')) offer.beforeNineLabel += 'rd ' + new DatePipe('en-GB').transform(date, 'MMMM');
    else if (offer.beforeNineLabel.endsWith('1') || offer.beforeNineLabel.endsWith('2') || offer.beforeNineLabel.endsWith('3') || offer.beforeNineLabel.endsWith('4') || offer.beforeNineLabel.endsWith('5') || offer.beforeNineLabel.endsWith('6')
      || offer.beforeNineLabel.endsWith('7') || offer.beforeNineLabel.endsWith('8') || offer.beforeNineLabel.endsWith('9')
      || offer.beforeNineLabel.endsWith('0')) offer.beforeNineLabel += 'th ' + new DatePipe('en-GB').transform(date, 'MMMM');

    if (updateOthers) {
      if ((offer.day === 'Friday' || offer.day === 'Saturday' || offer.day === 'Sunday') && offer.type === 'Bar' && (offer.afterNineDirty || offer.beforeNineDirty)) {
        if ((!(!offer.afterNine && offer.showPendingTrueAfterNine) && !(offer.afterNine && !offer.showPendingFalseAfterNine))
          && (!(!offer.beforeNine && offer.showPendingTrueBeforeNine) && !(offer.beforeNine && !offer.showPendingFalseBeforeNine))
          && (offer.isLive || offer.showPendingTrueIsLive)) {

          offer.isLiveDirty = true;
          offer.perk = false;
          this.updateOfferPerk(offer, offer.isLive ? 'pendingFalse' : 'initial');
          this.updateOfferIsLive(offer, offer.isLive ? 'pendingFalse' : 'initial', false);
        }
      }
    }

  }


  updateRestaurantMaxPartySize() {

    let date = null;

    for (const offer of this.restaurantOffers) {

      if (offer.type !== 'Bar') {

        offer.maxPartySize = parseInt(this.selectedMaxPartySizeRestaurant.id); // no, it does not miss radix parameter (error from webstorm)

        if (!offer.maxPartySize) {
          offer.maxPartySize = offer.pendingMaxPartySize;
        }

        const oldOffer = this.oldOffersRestaurant.find(x => x.type === 'Restaurant' && x.day === offer.day);

        if (this.selectedMaxPartySizeRestaurant.id !== 'increase' && this.selectedMaxPartySizeRestaurant.id !== 'decrease' && !this.maxPartySizeOptionsRestaurantDirty) {
          this.maxPartySizeChangeRestaurantLabel = '';
          return;
        }

        // let date = null;
        // if (oldOffer.pendingMaxPartySizeTime) {
        //   const fullDate = new Date(oldOffer.pendingMaxPartySizeTime);
        //   date = new Date(fullDate.getUTCFullYear(), fullDate.getUTCMonth(), fullDate.getUTCDate(), fullDate.getUTCHours(), fullDate.getUTCMinutes(), fullDate.getUTCSeconds());
        // }

        if (oldOffer.pendingMaxPartySizeTime) {

          date = new Date(Math.max.apply(null, this.oldOffersRestaurant.map(function (off) {
            const fullDate = new Date(off.pendingMaxPartySizeTime);
            return new Date(fullDate.getUTCFullYear(), fullDate.getUTCMonth(), fullDate.getUTCDate(), fullDate.getUTCHours(), fullDate.getUTCMinutes(), fullDate.getUTCSeconds());
          })));

        }


        if (this.selectedMaxPartySizeRestaurant.id === 'increase' || this.selectedMaxPartySizeRestaurant.id === 'decrease') {
          this.maxPartySizeChangeRestaurantLabel = (this.selectedRestaurantStatus.id !== 'NotLive' && this.venue.id)
            ? (oldOffer.maxPartySize < offer.pendingMaxPartySize
              ? oldOffer.maxPartySize === offer.maxPartySize ? '' : ('Level will increase from ' + new DatePipe('en-US').transform(oldOffer.pendingMaxPartySizeTime, 'shortTime'))
              : oldOffer.maxPartySize === offer.maxPartySize ? '' : ('Level will decrease from ' + new DatePipe('en-GB').transform(date, 'EEEE d')))
            : '';
          if (oldOffer.maxPartySize === offer.maxPartySize && !oldOffer.pendingMaxPartySize) {
            this.maxPartySizeChangeRestaurantLabel = (this.selectedRestaurantStatus.id !== 'NotLive' && this.venue.id) ? (!date ? '' : 'Level will remain the same') : '';
          }
        } else {
          this.maxPartySizeChangeRestaurantLabel = (this.selectedRestaurantStatus.id !== 'NotLive' && this.venue.id)
            ? oldOffer.maxPartySize === offer.maxPartySize ? (!date ? '' : 'Level will remain the same') : (oldOffer.maxPartySize < offer.maxPartySize ? 'Level will increase in 1 hr' : 'Level will decrease from ' + this.getDateLabel7Days())
            : '';
        }

        if (this.maxPartySizeChangeRestaurantLabel.endsWith('1') && !this.maxPartySizeChangeRestaurantLabel.endsWith(' 11')) this.maxPartySizeChangeRestaurantLabel += 'st ' + new DatePipe('en-GB').transform(date, 'MMMM');
        else if (this.maxPartySizeChangeRestaurantLabel.endsWith('2') && !this.maxPartySizeChangeRestaurantLabel.endsWith(' 12')) this.maxPartySizeChangeRestaurantLabel += 'nd ' + new DatePipe('en-GB').transform(date, 'MMMM');
        else if (this.maxPartySizeChangeRestaurantLabel.endsWith('3') && !this.maxPartySizeChangeRestaurantLabel.endsWith(' 13')) this.maxPartySizeChangeRestaurantLabel += 'rd ' + new DatePipe('en-GB').transform(date, 'MMMM');
        else if (this.maxPartySizeChangeRestaurantLabel.endsWith('1') || this.maxPartySizeChangeRestaurantLabel.endsWith('2') || this.maxPartySizeChangeRestaurantLabel.endsWith('3') || this.maxPartySizeChangeRestaurantLabel.endsWith('4') || this.maxPartySizeChangeRestaurantLabel.endsWith('5') || this.maxPartySizeChangeRestaurantLabel.endsWith('6')
          || this.maxPartySizeChangeRestaurantLabel.endsWith('7') || this.maxPartySizeChangeRestaurantLabel.endsWith('8') || this.maxPartySizeChangeRestaurantLabel.endsWith('9')
          || this.maxPartySizeChangeRestaurantLabel.endsWith('0')) this.maxPartySizeChangeRestaurantLabel += 'th ' + new DatePipe('en-GB').transform(date, 'MMMM');


      }

      offer.pendingMaxPartySize = offer.maxPartySize;

    }
  }

  updateBarOfferDetails() {

    let date = null;

    for (const offer of this.barOffers) {

      if (offer.type === 'Bar') {
        offer.totalBill = this.selectedOfferOptionBar.id === 'total';

        const oldOffer = this.oldOffersBar.find(x => x.type === 'Bar' && x.day === offer.day);

        if (this.selectedOfferOptionBar.id !== 'increase' && this.selectedOfferOptionBar.id !== 'decrease' && !this.offerOptionsBarDirty) {
          this.offerTypeChangeBarLabel = '';
          return;
        }

        // let date = null;
        // if (oldOffer.pendingTotalBillTime) {
        //   const fullDate = new Date(oldOffer.pendingTotalBillTime);
        //   date = new Date(fullDate.getUTCFullYear(), fullDate.getUTCMonth(), fullDate.getUTCDate(), fullDate.getUTCHours(), fullDate.getUTCMinutes(), fullDate.getUTCSeconds());
        // }

        if (oldOffer.pendingTotalBillTime) {

          date = new Date(Math.max.apply(null, this.oldOffersBar.map(function (off) {
            const fullDate = new Date(off.pendingTotalBillTime);
            return new Date(fullDate.getUTCFullYear(), fullDate.getUTCMonth(), fullDate.getUTCDate(), fullDate.getUTCHours(), fullDate.getUTCMinutes(), fullDate.getUTCSeconds());
          })));

        }

        if (this.selectedOfferOptionBar.id === 'increase' || this.selectedOfferOptionBar.id === 'decrease') {
          this.offerTypeChangeBarLabel = (this.selectedBarStatus.id !== 'NotLive' && this.venue.id)
            ? (this.selectedOfferOptionBar.id === 'increase'
              ? 'Level will increase from ' + new DatePipe('en-US').transform(oldOffer.pendingTotalBillTime, 'shortTime')
              : 'Level will decrease from ' + new DatePipe('en-GB').transform(date, 'EEEE d'))
            : '';

        } else {
          this.offerTypeChangeBarLabel = (this.selectedBarStatus.id !== 'NotLive' && this.venue.id)
            ? oldOffer.totalBill === offer.totalBill ? (!date ? '' : 'Level will remain the same') : (offer.totalBill ? 'Level will increase in 1 hr' : 'Level will decrease from ' + this.getDateLabel7Days())
            : '';
          if (oldOffer.totalBill === offer.totalBill && !oldOffer.pendingTotalBill) {
            this.offerTypeChangeBarLabel = (this.selectedBarStatus.id !== 'NotLive' && this.venue.id) ? (!date ? '' : 'Level will remain the same') : '';
          }
        }

        if (this.offerTypeChangeBarLabel.endsWith('1') && !this.offerTypeChangeBarLabel.endsWith(' 11')) this.offerTypeChangeBarLabel += 'st ' + new DatePipe('en-GB').transform(date, 'MMMM');
        else if (this.offerTypeChangeBarLabel.endsWith('2') && !this.offerTypeChangeBarLabel.endsWith(' 12')) this.offerTypeChangeBarLabel += 'nd ' + new DatePipe('en-GB').transform(date, 'MMMM');
        else if (this.offerTypeChangeBarLabel.endsWith('3') && !this.offerTypeChangeBarLabel.endsWith(' 13')) this.offerTypeChangeBarLabel += 'rd ' + new DatePipe('en-GB').transform(date, 'MMMM');
        else if (this.offerTypeChangeBarLabel.endsWith('1') || this.offerTypeChangeBarLabel.endsWith('2') || this.offerTypeChangeBarLabel.endsWith('3') || this.offerTypeChangeBarLabel.endsWith('4') || this.offerTypeChangeBarLabel.endsWith('5') || this.offerTypeChangeBarLabel.endsWith('6')
          || this.offerTypeChangeBarLabel.endsWith('7') || this.offerTypeChangeBarLabel.endsWith('8') || this.offerTypeChangeBarLabel.endsWith('9')
          || this.offerTypeChangeBarLabel.endsWith('0')) this.offerTypeChangeBarLabel += 'th ' + new DatePipe('en-GB').transform(date, 'MMMM');

      }

      offer.pendingTotalBill = offer.totalBill;

    }
  }

  updateBarMaxPartySize() {

    let date = null;

    for (const offer of this.barOffers) {

      if (offer.type === 'Bar') {

        offer.maxPartySize = parseInt(this.selectedMaxPartySizeBar.id); // no, it does not miss radix parameter (error from webstorm)

        if (!offer.maxPartySize) {
          offer.maxPartySize = offer.pendingMaxPartySize;
        }

        const oldOffer = this.oldOffersBar.find(x => x.type === 'Bar' && x.day === offer.day);

        if (this.selectedMaxPartySizeBar.id !== 'increase' && this.selectedMaxPartySizeBar.id !== 'decrease' && !this.maxPartySizeOptionsBarDirty) {
          this.maxPartySizeChangeBarLabel = '';
          return;
        }

        // let date = null;
        // if (oldOffer.pendingMaxPartySizeTime) {
        //   const fullDate = new Date(oldOffer.pendingMaxPartySizeTime);
        //   date = new Date(fullDate.getUTCFullYear(), fullDate.getUTCMonth(), fullDate.getUTCDate(), fullDate.getUTCHours(), fullDate.getUTCMinutes(), fullDate.getUTCSeconds());
        // }

        if (oldOffer.pendingMaxPartySizeTime) {

          date = new Date(Math.max.apply(null, this.oldOffersBar.map(function (off) {
            const fullDate = new Date(off.pendingMaxPartySizeTime);
            return new Date(fullDate.getUTCFullYear(), fullDate.getUTCMonth(), fullDate.getUTCDate(), fullDate.getUTCHours(), fullDate.getUTCMinutes(), fullDate.getUTCSeconds());
          })));

        }

        if (this.selectedMaxPartySizeBar.id === 'increase' || this.selectedMaxPartySizeBar.id === 'decrease') {
          this.maxPartySizeChangeBarLabel = (this.selectedBarStatus.id !== 'NotLive' && this.venue.id)
            ? (oldOffer.maxPartySize < offer.pendingMaxPartySize
              ? oldOffer.maxPartySize === offer.maxPartySize ? 'Level will remain the same' : ('Level will increase from ' + new DatePipe('en-US').transform(oldOffer.pendingMaxPartySizeTime, 'shortTime'))
              : oldOffer.maxPartySize === offer.maxPartySize ? 'Level will remain the same' : ('Level will decrease from ' + new DatePipe('en-GB').transform(date, 'EEEE d')))
            : '';
        } else {
          this.maxPartySizeChangeBarLabel = (this.selectedBarStatus.id !== 'NotLive' && this.venue.id)
            ? (oldOffer.maxPartySize === offer.maxPartySize ? (!date ? '' : 'Level will remain the same') : (oldOffer.maxPartySize < offer.maxPartySize ? 'Level will increase in 1 hr' : 'Level will decrease from ' + this.getDateLabel7Days()))
            : '';
        }

        if (this.maxPartySizeChangeBarLabel.endsWith('1') && !this.maxPartySizeChangeBarLabel.endsWith(' 11')) this.maxPartySizeChangeBarLabel += 'st ' + new DatePipe('en-GB').transform(date, 'MMMM');
        else if (this.maxPartySizeChangeBarLabel.endsWith('2') && !this.maxPartySizeChangeBarLabel.endsWith(' 12')) this.maxPartySizeChangeBarLabel += 'nd ' + new DatePipe('en-GB').transform(date, 'MMMM');
        else if (this.maxPartySizeChangeBarLabel.endsWith('3') && !this.maxPartySizeChangeBarLabel.endsWith(' 13')) this.maxPartySizeChangeBarLabel += 'rd ' + new DatePipe('en-GB').transform(date, 'MMMM');
        else if (this.maxPartySizeChangeBarLabel.endsWith('1') || this.maxPartySizeChangeBarLabel.endsWith('2') || this.maxPartySizeChangeBarLabel.endsWith('3') || this.maxPartySizeChangeBarLabel.endsWith('4') || this.maxPartySizeChangeBarLabel.endsWith('5') || this.maxPartySizeChangeBarLabel.endsWith('6')
          || this.maxPartySizeChangeBarLabel.endsWith('7') || this.maxPartySizeChangeBarLabel.endsWith('8') || this.maxPartySizeChangeBarLabel.endsWith('9')
          || this.maxPartySizeChangeBarLabel.endsWith('0')) this.maxPartySizeChangeBarLabel += 'th ' + new DatePipe('en-GB').transform(date, 'MMMM');


      }

      offer.pendingMaxPartySize = offer.maxPartySize;

    }
  }


  checkLunchDinerOfferCB(offer: VenueDetailsOffer, field: string) {
    if (field === 'lunch' || field === 'dinner') {
      if (!offer.lunch && !offer.dinner) {
        offer.isLive = false;
        offer.perk = false
      }
    } else if (field === 'isLive') {
      if (offer.isLive) {
        offer.lunch = true;
        offer.dinner = true;
      } else {
        offer.lunch = false;
        offer.dinner = false;
        offer.perk = false;
      }
    }
  }

  check9pmOfferCB(offer: VenueDetailsOffer, field: string) {
    if (field === 'before' || field === 'after') {
      if (!offer.beforeNine && !offer.afterNine) {
        offer.isLive = false;
        offer.perk = false
      }
    } else if (field === 'isLive') {
      if (offer.isLive) {
        offer.beforeNine = true;
        offer.afterNine = true;
      } else {
        offer.beforeNine = false;
        offer.afterNine = false;
        offer.perk = false;
      }
    }
  }


  refreshVisitsList() {
    this.filteredVisits = new Array();
    if (this.selectedVisitsHistoryPeriod.id === 'lastMonth') {
      const currentTime = new Date();
      let month = currentTime.getMonth() - 1;
      let year = currentTime.getFullYear();
      if (month === -1) {
        month = 11;
        year -= 1;
      }
      for (const visit of this.venue.visits) {
        const visitDate = new Date(visit.timeOfVisit);
        if (visitDate.getFullYear() === year && visitDate.getMonth() === month) {
          this.filteredVisits.push(visit);
        }
      }
    } else if (this.selectedVisitsHistoryPeriod.id === 'currentMonth') {
      const currentTime = new Date();
      let month = currentTime.getMonth();
      let year = currentTime.getFullYear();
      if (month === -1) {
        month = 12;
        year -= 1;
      }
      for (const visit of this.venue.visits) {
        const visitDate = new Date(visit.timeOfVisit);
        if (visitDate.getFullYear() === year && visitDate.getMonth() === month) {
          this.filteredVisits.push(visit);
        }
      }
    } else if (this.selectedVisitsHistoryPeriod.id === 'all') {
      for (const visit of this.venue.visits) {
        this.filteredVisits.push(visit);
      }
    }
    this.calculateRevenue();
  }

  initStatuses() {
    for (const status of this.barStatusOptions) {
      if (this.barSubsidiaryData.status === status.id) {
        this.selectedBarStatus = status;
        this.pendingBarStatus = status;
        break;
      } else {
        if (!this.selectedVenueId && status.id === 'NotLive') {
          this.selectedBarStatus = status;
          this.pendingBarStatus = status;
          break;
        }
      }
    }
    if (!this.selectedBarStatus && this.barStatusOptions) {
      this.selectedBarStatus = this.barStatusOptions[1];
      this.pendingBarStatus = this.barStatusOptions[1];

    }
    for (const status of this.restaurantStatusOptions) {
      if (this.restaurantSubsidiaryData.status === status.id) {
        this.selectedRestaurantStatus = status;
        this.pendingRestaurantStatus = status;
        break;
      } else {
        if (!this.selectedVenueId && status.id === 'NotLive') {
          this.selectedRestaurantStatus = status;
          this.pendingRestaurantStatus = status;
          break;
        }
      }
    }
    if (!this.selectedRestaurantStatus && this.restaurantStatusOptions) {
      this.selectedRestaurantStatus = this.restaurantStatusOptions[1];
      this.pendingRestaurantStatus = this.restaurantStatusOptions[1];
    }
  }

  close(forced) {
    if (this.buttonsEnabled || forced) {
      if (this.StateChanged() && !forced) {
        this.closeVenue = true;
      } else {
        this.closeConfirmed();
      }
    }
  }

  closeConfirmed() {
    if (this.buttonsEnabled) {
      this.showVenueChange.emit(false);
    }
  }

  addOrUpdateContact(index?) {
    if (index != null) {
      this.selectedContact = <VenueDetailsContact>JSON.parse(JSON.stringify(this.venue.contacts[index]));
      this.selectedContactIndex = index;
    } else {
      this.selectedContact = new VenueDetailsContact();
      this.selectedContactIndex = -1;
      this.selectedContact.new = true;
    }
    this.addContact = true;
  }

  openCuisinesEditRestaurant() {

    this.cuisineOptions = this.allCuisines.map(z => {
      return {
        id: z.id,
        name: z.name,
        selected: this.restaurantSubsidiaryData.cuisines.indexOf(z.id) >= 0
      }
    });

    this.editCuisinesRestaurant = true;
  }

  saveCuisinesRestaurant() {
    this.restaurantSubsidiaryData.cuisines = this.cuisineOptions.filter(z => z.selected).map(z => z.id);
    this.restaurantSubsidiaryData.cuisinesString = this.restaurantSubsidiaryData.cuisines.length + " cuisine" + (this.restaurantSubsidiaryData.cuisines.length == 1 ? "" : "s");
    this.editCuisinesRestaurant = false;
  }

  openCuisinesEditBar() {

    this.cuisineOptions = this.allCuisines.map(z => {
      return {
        id: z.id,
        name: z.name,
        selected: this.barSubsidiaryData.cuisines.indexOf(z.id) >= 0
      }
    });

    this.editCuisinesBar = true;
  }

  saveCuisinesBar() {
    this.barSubsidiaryData.cuisines = this.cuisineOptions.filter(z => z.selected).map(z => z.id);
    this.barSubsidiaryData.cuisinesString = this.barSubsidiaryData.cuisines.length + " cuisine" + (this.barSubsidiaryData.cuisines.length == 1 ? "" : "s");
    this.editCuisinesBar = false;
  }

  openVibesEditRestaurant() {

    this.vibeOptions = this.allVibes.map(z => {
      return {
        id: z.id,
        name: z.name,
        selected: this.restaurantSubsidiaryData.vibes.indexOf(z.id) >= 0
      }
    });

    this.editVibesRestaurant = true;
  }

  saveVibesRestaurant() {
    this.restaurantSubsidiaryData.vibes = this.vibeOptions.filter(z => z.selected).map(z => z.id);
    this.restaurantSubsidiaryData.vibesString = this.restaurantSubsidiaryData.vibes.length + " vibe" + (this.restaurantSubsidiaryData.vibes.length == 1 ? "" : "s");
    this.editVibesRestaurant = false;
  }

  openVibesEditBar() {

    this.vibeOptions = this.allVibes.map(z => {
      return {
        id: z.id,
        name: z.name,
        selected: this.barSubsidiaryData.vibes.indexOf(z.id) >= 0
      }
    });

    this.editVibesBar = true;
  }

  saveVibesBar() {
    this.barSubsidiaryData.vibes = this.vibeOptions.filter(z => z.selected).map(z => z.id);
    this.barSubsidiaryData.vibesString = this.barSubsidiaryData.vibes.length + " vibe" + (this.barSubsidiaryData.vibes.length == 1 ? "" : "s");
    this.editVibesBar = false;
  }

  addOrUpdateSubArea() {
    if (this.selectedSubArea.id == -1) {
      this.addSubArea = true;
      this.selectedSubArea = this.subAreaOptions[0];
    }
  }

  useGroupContacts() {
    this.venueDetailsService.getGroupContacts(this.venue.groupId)
      .subscribe(
        (response) => {
          console.log(response);
          if (response.length === 0) {
            this.showGroupHasNoContact = true;
          } else {
            this.venue.contacts = response;
          }
        },
        (error) => console.log(error)
      );

  }

  closePopUp() {
    this.showGroupHasNoContact = false;
  }

  show(id) {
    this.switchVenueDestination = id;
    if (this.StateChanged()) {
      this.switchVenue = true;
    } else {
      this.venueSwitchConfirmed();
    }
  }

  newVenue() {
    this.switchVenueDestination = null;

    if (this.StateChanged()) {
      this.switchVenue = true;

    } else {
      this.venueSwitchConfirmed();
    }
  }

  venueSwitchConfirmed() {
    this.switchVenue = false;
    this.showVenueChange.emit(false);
    if (this.switchVenueDestination === null) { // new venue
      this.selectedVenueId = null;
      this.newVenueEvent.emit(this.venue.groupId);
    } else {
      this.selectedVenueId = this.switchVenueDestination;
      this.switchVenueEvent.emit(this.switchVenueDestination);
    }
  }


  venueSaveSwitch() {
    this.switchVenue = false;
    this.saveConfirmed();
    this.showVenueChange.emit(false);
    if (this.switchVenueDestination === null) { // new venue
      this.selectedVenueId = null;
      this.newVenueEvent.emit(this.venue.groupId);

    } else {
      this.selectedVenueId = this.switchVenueDestination;
      this.switchVenueEvent.emit(this.switchVenueDestination);

    }
  }

  saveContact(valid) {
    if (valid) {
      if (this.selectedContactIndex > -1) {
        this.venue.contacts[this.selectedContactIndex] = this.selectedContact;
      } else {
        this.venue.contacts.push(this.selectedContact);
      }
      this.addContact = false;
    }
  }

  saveNewSubArea() {
    if (!this.newSubArea) return;
    this.venueDetailsService.addSubArea(this.selectedLocation.id, this.newSubArea).subscribe((list) => {
      this.allSubAreas = list.map(z => new GroupedEnumModel(z.id, z.subAreas));

      // this.addSubArea = false;
      for (const location of this.allSubAreas) {
        if (this.selectedLocation.id === location.id) {
          this.subAreaOptions = location.value;
          this.editSubAreaOptions = location.value.map(z => {
            return {
              id: z.id,
              name: z.name,
              selected: false
            }
          });
          this.subAreaOptions.unshift(new EnumModel(0, "Not selected"));
          this.subAreaOptions.push(new EnumModel(-1, "🖉 EDIT LIST"));
        }
      }

      for (const subArea of this.subAreaOptions) {
        if (subArea.name === this.newSubArea) {
          this.selectedSubArea = subArea;
        }
      }

      this.newSubArea = "";
    });
  }

  addCuisine() {
    this.venueDetailsService.addCuisine(this.newCuisine).subscribe((list) => {
      this.allCuisines = list;
      let selectedCuisines = this.cuisineOptions.filter(z => z.selected).map(z => z.id);
      this.cuisineOptions = this.allCuisines.map(z => {
        return {
          id: z.id,
          name: z.name,
          selected: selectedCuisines.indexOf(z.id) >= 0
        }
      });

      this.newCuisine = "";
    });
  }

  deleteCuisine(id) {
    this.venueDetailsService.deleteCuisines(id).subscribe((list) => {
      this.allCuisines = list;
      let selectedCuisines = this.cuisineOptions.filter(z => z.selected).map(z => z.id);
      this.cuisineOptions = this.allCuisines.map(z => {
        return {
          id: z.id,
          name: z.name,
          selected: selectedCuisines.indexOf(z.id) >= 0
        }
      });
    });
  }

  deleteCuisines(id) {
    this.venueDetailsService.deleteCuisines(this.cuisineOptions.filter(z => z.selected).map(z => z.id)).subscribe((list) => {
      this.allCuisines = list;
      let selectedCuisines = this.cuisineOptions.filter(z => z.selected).map(z => z.id);
      this.cuisineOptions = this.allCuisines.map(z => {
        return {
          id: z.id,
          name: z.name,
          selected: selectedCuisines.indexOf(z.id) >= 0
        }
      });
    });

    this.deleteCuisinesConfirm = false;
  }

  addVibe() {
    if (!this.newVibe || !this.newVibe.trim()) {
      return;
    }

    this.venueDetailsService.addVibe(this.newVibe.trim()).subscribe((list) => {
      this.allVibes = list;
      let selectedVibes = this.vibeOptions.filter(z => z.selected).map(z => z.id);
      this.vibeOptions = this.allVibes.map(z => {
        return {
          id: z.id,
          name: z.name,
          selected: selectedVibes.indexOf(z.id) >= 0
        }
      });

      this.newVibe = "";
    });
  }

  deleteVibes() {
    this.venueDetailsService.deleteVibes(this.vibeOptions.filter(z => z.selected).map(z => z.id)).subscribe((list) => {
      this.allVibes = list;
      let selectedVibes = this.vibeOptions.filter(z => z.selected).map(z => z.id);
      this.vibeOptions = this.allVibes.map(z => {
        return {
          id: z.id,
          name: z.name,
          selected: selectedVibes.indexOf(z.id) >= 0
        }
      });
    });

    this.deleteVibesConfirm = false;
  }

  deleteSubAreas() {
    this.venueDetailsService.deleteSubAreas(this.editSubAreaOptions.filter(z => z.selected).map(z => z.id)).subscribe((list) => {
      this.allSubAreas = list.map(z => new GroupedEnumModel(z.id, z.subAreas));
      for (const location of this.allSubAreas) {
        if (this.selectedLocation.id === location.id) {
          this.subAreaOptions = location.value;
          this.editSubAreaOptions = location.value.map(z => {
            return {
              id: z.id,
              name: z.name,
              selected: false
            }
          });
          this.subAreaOptions.unshift(new EnumModel(0, "Not selected"));
          this.subAreaOptions.push(new EnumModel(-1, "🖉 EDIT LIST"));
        }
      }

    });

    this.deleteSubAreasConfirm = false;
  }

  deleteContact(index) {
    this.selectedContactIndex = index;
    this.venue.contacts.splice(index, 1);
  }

  tooglePartySizeEdit(index) {
    const visit = this.venue.visits[index];
    if (!visit.editMode) {
      visit.newPartySize = visit.partySize;
      visit.editMode = true;
      this.cancelPartySizeEditForOtherVisits(index);
    } else {
      if (visit.newPartySize as number === visit.oldPartySize) {
        visit.oldPartySize = null;
      } else if (!visit.oldPartySize && visit.newPartySize !== visit.partySize) {
        visit.oldPartySize = visit.partySize;
      }
      visit.partySize = visit.newPartySize;
      this.calculateRevenue();
      visit.editMode = false;
    }
  }

  cancelPartySizeEditForOtherVisits(index) {
    for (let i = 0; i < this.filteredVisits.length; i++) {
      if (i !== index) {
        this.filteredVisits[i].newPartySize = null;
        this.filteredVisits[i].editMode = false;
      }
    }
  }

  deleteVisit(index) {
    if (index < this.filteredVisits.length) {
      const indexInAllVisits = this.venue.visits.indexOf(this.filteredVisits[index]);
      this.filteredVisits.splice(index, 1);
      this.venue.visits.splice(indexInAllVisits, 1);
      this.calculateRevenue();
    }
  }

  delete() {
    this.deleteVenue = true;
  }

  calculateRevenue() {
    let newrevenue = 0;
    let newCoversCount = 0;
    let newTransactions = 0;
    let newPerkVisits = 0;
    for (const visit of this.filteredVisits) {
      newrevenue += visit.partySize * visit.ratePerCover;
      newCoversCount += visit.partySize;
      newTransactions += 1;
      if (visit.isPerkUsed) {
        newPerkVisits = newPerkVisits + visit.partySize;
      }

    }
    this.revenueForPeriod = newrevenue;
    this.coversForPeriod = newCoversCount;
    this.transactionsForPeriod = newTransactions;
    this.perksVisitsForPeriod = newPerkVisits;
  }

  getVenuesOrder(type, modal, init) {
    this.currentVenueOrderListBar = new VenuePositionListModel();
    this.currentVenueOrderListRestaurant = new VenuePositionListModel();
    this.currentVenueOrderListType = type;
    this.venueDetailsService.getVenueOrder(type).subscribe(
      (resp) => {

        if (type === 'Bar') {

          this.currentVenueOrderListBar = resp;
          let existing = false;
          for (const venue of this.currentVenueOrderListBar.venues) {
            if (venue.id === this.venue.id) {
              existing = true;
              this.currentVenueOrderListIndexBar = this.currentVenueOrderListBar.venues.indexOf(venue) + 1;
              this.currentVenueOrderListVenueBar = venue;
              break;
            }
          }
          if (!existing) {

            this.currentVenueOrderListBar.venues.forEach((venue) => {
              venue.order++;
            })

            const position = new VenuePositionListItemModel();
            position.id = this.venue.id;
            position.name = this.venue.name;
            position.order = 1;
            this.currentVenueOrderListBar.venues.unshift(position);
            this.currentVenueOrderListIndexBar = this.currentVenueOrderListBar.venues.indexOf(position) + 1;
            this.currentVenueOrderListVenueBar = position;
          }

          if (modal) {
            this.showAppPositionBar = true;
          }

          this.setVenueNewPostionBar(modal);

        } else {

          this.currentVenueOrderListRestaurant = resp;
          let existing = false;
          for (const venue of this.currentVenueOrderListRestaurant.venues) {
            if (venue.id === this.venue.id) {
              existing = true;
              this.currentVenueOrderListIndexRestaurant = this.currentVenueOrderListRestaurant.venues.indexOf(venue) + 1;
              this.currentVenueOrderListVenueRestaurant = venue;
              break;
            }
          }
          if (!existing) {

            this.currentVenueOrderListRestaurant.venues.forEach((venue) => {
              venue.order++;
            })

            const position = new VenuePositionListItemModel();
            position.id = this.venue.id;
            position.name = this.venue.name;
            position.order = 1;
            this.currentVenueOrderListRestaurant.venues.unshift(position);
            this.currentVenueOrderListIndexRestaurant = this.currentVenueOrderListRestaurant.venues.indexOf(position) + 1;
            this.currentVenueOrderListVenueRestaurant = position;
          }
          if (modal) {
            this.showAppPositionRestaurant = true;
          }

          this.setVenueNewPostionRestaurant(modal);
        }

        if (init) {
          this.SaveInitialState();
        }

      }
    );
  }

  setVenueNewPostionBar(modal) {
    this.currentVenueOrderListIndexBar = this.currentVenueOrderListBar.venues.indexOf(this.currentVenueOrderListVenueBar) + 1;

    this.venue.orderListBar = new VenuePositionListModel;

    this.venue.orderListBar.venues = new Array<VenuePositionListItemModel>(this.currentVenueOrderListBar.venues.length);


    for (let i = 0; i < this.currentVenueOrderListBar.venues.length; i++) {
      const item = new VenuePositionListItemModel();

      item.id = this.currentVenueOrderListBar.venues[i].id;
      item.order = i + 1;

      this.venue.orderListBar.venues.push(item);
    }


    this.barSubsidiaryData.order = this.currentVenueOrderListIndexBar;


    if (!modal) {
      this.showAppPositionBar = false;
    }

  }


  setVenueNewPostionRestaurant(modal) {

    this.currentVenueOrderListIndexRestaurant = this.currentVenueOrderListRestaurant.venues.indexOf(this.currentVenueOrderListVenueRestaurant) + 1;

    this.venue.orderListRestaurant = new VenuePositionListModel;

    this.venue.orderListRestaurant.venues = new Array<VenuePositionListItemModel>(this.currentVenueOrderListRestaurant.venues.length);

    for (let i = 0; i < this.currentVenueOrderListRestaurant.venues.length; i++) {
      const item = new VenuePositionListItemModel();

      item.id = this.currentVenueOrderListRestaurant.venues[i].id;
      item.order = i + 1;

      this.venue.orderListRestaurant.venues.push(item);
    }


    this.restaurantSubsidiaryData.order = this.currentVenueOrderListIndexRestaurant;

    if (!modal) {
      this.showAppPositionRestaurant = false;
    }
  }

  cancel() {
    // if (this.buttonsEnabled) {
    this.switchVenue = false;
    this.addContact = false;
    this.addSubArea = false;
    this.deleteVenue = false;
    this.saveVenue = false;
    this.closeVenue = false;
    this.showAddCover = false;
    this.closeVenue = false;
    this.showSwitchToGroup = false;
    this.changeRestaurantStatus = false;
    this.changeBarStatus = false;
    this.changeVenueType = false;
    this.editCuisinesBar = false;
    this.editCuisinesRestaurant = false;
    this.editVibesBar = false;
    this.editVibesRestaurant = false;
    if (this.selectedSubArea.id == -1) {
      this.selectedSubArea = this.subAreaOptions[0];
    }
    // }

  }

  closeAppPositionBar() {
    this.showAppPositionBar = false;
  }

  closeAppPositionRestaurant() {
    this.showAppPositionRestaurant = false;
  }

  getDateLabel(offer: VenueDetailsOffer) {
    let addDays = 0;
    let day = 0;

    let date = new Date();
    date = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    date.setHours(date.getHours() + this.venue.utcOffset);

    const today = date.getDay();

    switch (offer.day) {
      case 'Monday': {
        day = 1;
        break;
      }
      case 'Tuesday': {
        day = 2;
        break;
      }
      case 'Wednesday': {
        day = 3;
        break;
      }
      case 'Thursday': {
        day = 4;
        break;
      }
      case 'Friday': {
        day = 5;
        break;
      }
      case 'Saturday': {
        day = 6;
        break;
      }
      case 'Sunday': {
        day = 0;
        break;
      }

      default:
        break;
    }

    if (day < today) {
      addDays = 7 - (today - day);
    } else {
      addDays = day - today;
    }


    date.setDate(date.getDate() + addDays + 1);


    let resultLabel = new DatePipe('en-GB').transform(date, 'EEEE d');

    if (resultLabel.endsWith('1') && !resultLabel.endsWith(' 11')) resultLabel += 'st ' + new DatePipe('en-GB').transform(date, 'MMMM');
    else if (resultLabel.endsWith('2') && !resultLabel.endsWith(' 12')) resultLabel += 'nd ' + new DatePipe('en-GB').transform(date, 'MMMM');
    else if (resultLabel.endsWith('3') && !resultLabel.endsWith(' 13')) resultLabel += 'rd ' + new DatePipe('en-GB').transform(date, 'MMMM');
    else if (resultLabel.endsWith('1') || resultLabel.endsWith('2') || resultLabel.endsWith('3')
      || resultLabel.endsWith('4') || resultLabel.endsWith('5') || resultLabel.endsWith('6')
      || resultLabel.endsWith('7') || resultLabel.endsWith('8') || resultLabel.endsWith('9')
      || resultLabel.endsWith('0')) resultLabel += 'th ' + new DatePipe('en-GB').transform(date, 'MMMM');

    return resultLabel;
  }


  getDateLabel7Days() {

    let date = new Date();
    date = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    date.setDate(date.getDate() + 6 + 1);

    date.setHours(date.getHours() + this.venue.utcOffset);

    let resultLabel = new DatePipe('en-GB').transform(date, 'EEEE d');

    if (resultLabel.endsWith('1') && !resultLabel.endsWith(' 11')) resultLabel += 'st ' + new DatePipe('en-GB').transform(date, 'MMMM');
    else if (resultLabel.endsWith('2') && !resultLabel.endsWith(' 12')) resultLabel += 'nd ' + new DatePipe('en-GB').transform(date, 'MMMM');
    else if (resultLabel.endsWith('3') && !resultLabel.endsWith(' 13')) resultLabel += 'rd ' + new DatePipe('en-GB').transform(date, 'MMMM');
    else if (resultLabel.endsWith('1') || resultLabel.endsWith('2') || resultLabel.endsWith('3')
      || resultLabel.endsWith('4') || resultLabel.endsWith('5') || resultLabel.endsWith('6')
      || resultLabel.endsWith('7') || resultLabel.endsWith('8') || resultLabel.endsWith('9')
      || resultLabel.endsWith('0')) resultLabel += 'th ' + new DatePipe('en-GB').transform(date, 'MMMM');

    return resultLabel;
  }


  save() {
    if (this.validate()) {
      if ((this.hasRestaurant && this.selectedRestaurantStatus != null && this.selectedRestaurantStatus.id !== 'NotLive') || (this.hasBar && this.selectedBarStatus != null && this.selectedBarStatus.id !== 'NotLive')) {
        this.saveVenue = true;
      } else {
        this.saveConfirmed();
      }
    }
  }

  saveConfirmed() {
    this.buttonsEnabled = false;
    if (this.restaurantSubsidiaryData) {
      this.restaurantSubsidiaryData.status = this.selectedRestaurantStatus.id;
    }
    if (this.barSubsidiaryData) {
      this.barSubsidiaryData.status = this.selectedBarStatus.id;
    }
    this.venue.subsidieries = new Array;
    if (this.selectedVenueType.id !== null) {
      if (this.selectedVenueType.id === 'Restaurant') {
        this.venue.subsidieries.push(this.restaurantSubsidiaryData);
      } else {
        this.venue.subsidieries.push(this.barSubsidiaryData);
      }
    } else {
      this.venue.subsidieries.push(this.restaurantSubsidiaryData);
      this.venue.subsidieries.push(this.barSubsidiaryData);
    }
    const files = new Array<File>();
    this.venue.venueImages = new Array<VenueDetailsImage>();
    this.venue.perkImages = new Array<VenueDetailsImage>();

    if (this.hasRestaurant && this.restaurantImages && this.restaurantImages.length > 0) {
      for (const img of this.restaurantImages) {
        if (img.data) {
          files.push(img.data);
          img.fileIndex = files.indexOf(img.data);
          const newImg = JSON.parse(JSON.stringify(img));
          newImg.data = null;
          newImg.url = null;
          this.venue.venueImages.push(newImg);
        } else {
          this.venue.venueImages.push(img);
        }
      }
    }

    if (this.hasBar && this.barImages && this.barImages.length > 0) {
      for (const img of this.barImages) {
        if (img.data) {
          files.push(img.data);
          img.fileIndex = files.indexOf(img.data);
          const newImg = JSON.parse(JSON.stringify(img));
          newImg.data = null;
          newImg.url = null;
          this.venue.venueImages.push(newImg);
        } else {
          this.venue.venueImages.push(img);
        }
      }
    }

    if (this.perkImages.length) {
      for (const img of this.perkImages) {
        if (img.data) {
          files.push(img.data);
          img.fileIndex = files.indexOf(img.data);
          const newImg = JSON.parse(JSON.stringify(img));
          newImg.data = null;
          newImg.url = null;
          this.venue.perkImages.push(newImg);
        } else {
          this.venue.perkImages.push(img);
        }
      }
    }

    this.venue.locationFilter = this.selectedLocation.id;
    this.venue.subAreaId = this.selectedSubArea.id;

    this.restaurantSubsidiaryData.price = this.selectedRestaurantPrice.id;
    this.barSubsidiaryData.price = this.selectedBarPrice.id;

    for (const s of this.venue.subsidieries) {
      s.name = this.venue.name;
    }


    this.statusHasChangedRestaurant = false;
    this.statusHasChangedBar = false;


    if (this.hasRestaurant && (!this.oldOffersRestaurant || this.oldOffersRestaurant.length === 0)) {
      this.initOffers(false, 'Restaurant');
    }

    if (this.hasBar && (!this.oldOffersBar || this.oldOffersBar.length === 0)) {
      this.initOffers(false, 'Bar');
    }

    this.venue.offers = new Array();

    for (const offer of this.restaurantOffers) {

      const oldOffer = this.oldOffersRestaurant.find(x => x.day === offer.day);

      if (this.selectedOfferOptionRestaurant && (this.selectedOfferOptionRestaurant.id === 'increase' || this.selectedOfferOptionRestaurant.id === 'decrease')) {
        offer.totalBill = this.oldOffersRestaurant.find(x => x.type === offer.type && x.day === offer.day).totalBill;

      }

      if (this.selectedMaxPartySizeRestaurant && (this.selectedMaxPartySizeRestaurant.id === 'increase' || this.selectedMaxPartySizeRestaurant.id === 'decrease')) {
        offer.maxPartySize = this.oldOffersRestaurant.find(x => x.type === offer.type && x.day === offer.day).maxPartySize;

      }

      if (!this.offerOptionsRestaurantDirty || (oldOffer.pendingTotalBill === offer.pendingTotalBill && oldOffer.totalBill === offer.totalBill)) {
        offer.pendingTotalBill = null;
      } else {
        offer.pendingTotalBill = offer.totalBill;
      }

      if (this.selectedOfferOptionRestaurant.id === 'increase' || this.selectedOfferOptionRestaurant.id === 'decrease') {
        offer.pendingTotalBill = null;
      }

      if (oldOffer.pendingMaxPartySize === offer.pendingMaxPartySize && oldOffer.maxPartySize === offer.maxPartySize) {
        offer.pendingMaxPartySize = null;
      } else {
        offer.pendingMaxPartySize = offer.maxPartySize;
      }

      if (oldOffer.pendingOfferRate === offer.pendingOfferRate && oldOffer.offerRate === offer.offerRate) {
        offer.pendingOfferRate = null;
      } else {
        offer.pendingOfferRate = offer.offerRate;
      }

      if (this.selectedRestaurantStatus.id === 'NotLive') {
        offer.pendingTotalBill = offer.totalBill;
        offer.pendingMaxPartySize = offer.maxPartySize;
      }

      if (offer.showPendingTrueIsLive) {
        offer.pendingIsLive = true;
      }

      this.updatePerkFlagsBeforeSave(offer, oldOffer)

      if (offer.showPendingFalseIsLive) {
        offer.pendingIsLive = false;
      }

      if (offer.showPendingFalsePerk) {
        offer.pendingPerk = false;
      }

      if (offer.showInitialIsLive) {
        offer.pendingIsLive = oldOffer.isLive;
      }

      if (!offer.isLiveDirty) {
        offer.pendingIsLive = null;
      }

      if (offer.showPendingTrueLunch) {
        offer.pendingLunch = true;
      }
      if (offer.showPendingFalseLunch) {
        offer.pendingLunch = false;
      }
      if (offer.showInitialLunch) {
        offer.pendingLunch = oldOffer.lunch;
      }
      if (!offer.lunchDirty) {
        offer.pendingLunch = null;
      }

      if (offer.showPendingTrueDinner) {
        offer.pendingDinner = true;
      }
      if (offer.showPendingFalseDinner) {
        offer.pendingDinner = false;
      }
      if (offer.showInitialDinner) {
        offer.pendingDinner = oldOffer.dinner;
      }
      if (!offer.dinnerDirty) {
        offer.pendingDinner = null;
      }

      if (offer.showPendingTrueAfterNine) {
        offer.pendingAfterNine = true;
      }
      if (offer.showPendingFalseAfterNine) {
        offer.pendingAfterNine = false;
      }
      if (offer.showInitialAfterNine) {
        offer.pendingAfterNine = oldOffer.afterNine;
      }
      if (!offer.afterNineDirty) {
        offer.pendingAfterNine = null;
      }

      if (offer.showPendingTrueBeforeNine) {
        offer.pendingBeforeNine = true;
      }
      if (offer.showPendingFalseBeforeNine) {
        offer.pendingBeforeNine = false;
      }
      if (offer.showInitialBeforeNine) {
        offer.pendingBeforeNine = oldOffer.beforeNine;
      }
      if (!offer.beforeNineDirty) {
        offer.pendingBeforeNine = null;
      }

      if (this.selectedRestaurantStatus.id === 'NotLive') {
        offer.pendingIsLive = offer.isLive;
        offer.pendingLunch = offer.lunch;
        offer.pendingDinner = offer.dinner;
        offer.pendingAfterNine = offer.afterNine;
        offer.pendingBeforeNine = offer.beforeNine;
      }


      if (!offer.maxPartySize) {
        offer.maxPartySize = 0;
      }

      this.venue.offers.push(Object.assign({}, offer));
    }

    for (const offer of this.barOffers) {

      const oldOffer = this.oldOffersBar.find(x => x.day === offer.day);

      if (this.selectedOfferOptionBar && (this.selectedOfferOptionBar.id === 'increase' || this.selectedOfferOptionBar.id === 'decrease')) {
        offer.totalBill = this.oldOffersBar.find(x => x.type === offer.type && x.day === offer.day).totalBill;

      }

      if (this.selectedMaxPartySizeBar && (this.selectedMaxPartySizeBar.id === 'increase' || this.selectedMaxPartySizeBar.id === 'decrease')) {
        offer.maxPartySize = this.oldOffersBar.find(x => x.type === offer.type && x.day === offer.day).maxPartySize;

      }

      if (!this.offerOptionsBarDirty || (oldOffer.pendingTotalBill === offer.pendingTotalBill && oldOffer.totalBill === offer.totalBill)) {
        offer.pendingTotalBill = null;
      } else {
        offer.pendingTotalBill = offer.totalBill;
      }

      if (this.selectedOfferOptionBar.id === 'increase' || this.selectedOfferOptionBar.id === 'decrease') {
        offer.pendingTotalBill = null;
      }

      if (oldOffer.pendingMaxPartySize === offer.pendingMaxPartySize && oldOffer.maxPartySize === offer.maxPartySize) {
        offer.pendingMaxPartySize = null;
      } else {
        offer.pendingMaxPartySize = offer.maxPartySize;
      }

      if (oldOffer.pendingOfferRate === offer.pendingOfferRate && oldOffer.offerRate === offer.offerRate) {
        offer.pendingOfferRate = null;
      } else {
        offer.pendingOfferRate = offer.offerRate;
      }

      if (this.selectedBarStatus.id === 'NotLive') {
        offer.pendingTotalBill = offer.totalBill;
        offer.pendingMaxPartySize = offer.maxPartySize;
      }

      if (offer.showPendingTrueIsLive) {
        offer.pendingIsLive = true;
      }
      if (offer.showPendingFalseIsLive) {
        offer.pendingIsLive = false;
      }
      if (offer.showInitialIsLive) {
        offer.pendingIsLive = oldOffer.isLive;
      }

      this.updatePerkFlagsBeforeSave(offer, oldOffer)

      if (!offer.isLiveDirty) {
        offer.pendingIsLive = null;
      }

      if (offer.showPendingTrueLunch) {
        offer.pendingLunch = true;
      }
      if (offer.showPendingFalseLunch) {
        offer.pendingLunch = false;
      }
      if (offer.showInitialLunch) {
        offer.pendingLunch = oldOffer.lunch;
      }
      if (!offer.lunchDirty) {
        offer.pendingLunch = null;
      }

      if (offer.showPendingTrueDinner) {
        offer.pendingDinner = true;
      }
      if (offer.showPendingFalseDinner) {
        offer.pendingDinner = false;
      }
      if (offer.showInitialDinner) {
        offer.pendingDinner = oldOffer.dinner;
      }
      if (!offer.dinnerDirty) {
        offer.pendingDinner = null;
      }

      if (offer.showPendingTrueAfterNine) {
        offer.pendingAfterNine = true;
      }
      if (offer.showPendingFalseAfterNine) {
        offer.pendingAfterNine = false;
      }
      if (offer.showInitialAfterNine) {
        offer.pendingAfterNine = oldOffer.afterNine;
      }
      if (!offer.afterNineDirty) {
        offer.pendingAfterNine = null;
      }

      if (offer.showPendingTrueBeforeNine) {
        offer.pendingBeforeNine = true;
      }
      if (offer.showPendingFalseBeforeNine) {
        offer.pendingBeforeNine = false;
      }
      if (offer.showInitialBeforeNine) {
        offer.pendingBeforeNine = oldOffer.beforeNine;
      }
      if (!offer.beforeNineDirty) {
        offer.pendingBeforeNine = null;
      }

      if (this.selectedBarStatus.id === 'NotLive') {
        offer.pendingIsLive = offer.isLive;
        offer.pendingLunch = offer.lunch;
        offer.pendingDinner = offer.dinner;
        offer.pendingAfterNine = offer.afterNine;
        offer.pendingBeforeNine = offer.beforeNine;
      }

      if (!offer.maxPartySize) {
        offer.maxPartySize = 0;
      }

      this.venue.offers.push(Object.assign({}, offer));
    }

    this.venue.perkDescription = this.perkDescription;
    this.venue.isBulkNotifications = this.isBulkNotifications;

    if (this.venue.id !== 0) {
      this.venueDetailsService.update(this.venue, files)
        .subscribe(
          (response) => {
            this.cancel();
            this.changeTabAfterInit = true;
            this.ngOnInit();
            this.clearOfferLabels();

            setTimeout(() => {
              this.sliderComponents.forEach(slider => {
                slider.setCurrentValuePositionEvent();

              });
            }, 1100);

          }, (error) => {
            this.buttonsEnabled = true;
            this.cancel();
          });
    } else {
      this.venueDetailsService.new(this.venue, files).subscribe(
        (response) => {
          this.cancel();
          this.selectedVenueId = response;
          this.changeTabAfterInit = true;
          this.ngOnInit();
          this.clearOfferLabels();

          setTimeout(() => {
            this.sliderComponents.forEach(slider => {

              slider.setCurrentValuePositionEvent();

            });
          }, 1100);
        }, (error) => {
          this.buttonsEnabled = true;
          this.cancel();
        });
    }
  }

  validate() {
    let errorMsg = '';
    if (!this.venue.name || this.venue.name === '') {
      errorMsg += 'Venue name is required.\n';
    }
    if (!this.venue.address || this.venue.address === '') {
      errorMsg += 'Venue address is required.\n';
    }
    // if (!this.venue.phoneNumber || this.venue.phoneNumber === '') {
    //   errorMsg += 'Venue phone number is required.\n';
    // }
    if (!this.venue.specificLocation || this.venue.specificLocation === '') {
      errorMsg += 'Specific location is required.\n';
    }
    if (!this.venue.location) {
      errorMsg += 'Venue location is required.\n';

    }
    if (this.hasBar && this.selectedBarStatus.id !== 'NotLive') {
      if (!this.barSubsidiaryData.venueCategory || this.barSubsidiaryData.venueCategory === '') {
        errorMsg += 'Cuisine for bar is required.\n';
      }
    }
    if (this.hasRestaurant && this.selectedRestaurantStatus.id !== 'NotLive') {
      if (!this.restaurantSubsidiaryData.venueCategory || this.restaurantSubsidiaryData.venueCategory === '') {
        errorMsg += 'Cuisine for restaurant is required.\n';
      }
    }

    if (this.venue.name && this.venue.name.length > 50) {
      errorMsg += 'Name too long (max 50 characters). \n';
    }
    if (this.venue.address && this.venue.address.length > 100) {
      errorMsg += 'Address too long (max 100 characters).\n';
    }
    if (this.venue.phoneNumber && this.venue.phoneNumber.length > 50) {
      errorMsg += 'Phone Number too long (max 50 characters). \n';
    }
    if (this.venue.specificLocation && this.venue.specificLocation.length > 50) {
      errorMsg += 'Specific Location too long (max 50 characters).\n';
    }
    if (this.venue.note && this.venue.note.length > 500) {
      errorMsg += 'Note too long (max 500 characters).\n';
    }

    if (this.hasBar) {
      if (this.barSubsidiaryData.venueCategory && this.barSubsidiaryData.venueCategory.length > 50) {
        errorMsg += 'Bar cuisine too long (max 50 characters).\n';
      }
      if (this.barSubsidiaryData.menuPageUrl && this.barSubsidiaryData.menuPageUrl.length > 100) {
        errorMsg += 'Menu page URL address (link) for bar is too long (max 100 characters).\n';
      }
    }
    if (this.hasRestaurant) {
      if (this.restaurantSubsidiaryData.venueCategory && this.restaurantSubsidiaryData.venueCategory.length > 50) {
        errorMsg += 'Restaurant cuisine too long (max 50 characters).\n';
      }
      if (this.restaurantSubsidiaryData.menuPageUrl && this.restaurantSubsidiaryData.menuPageUrl.length > 100) {
        errorMsg += 'Menu page URL address (link) for restaurant is too long (max 100 characters).\n';
      }
    }

    if (errorMsg !== '') {
      const toast: Toast = {
        type: 'error',
        title: 'Error',
        body: errorMsg,
        showCloseButton: true,
        timeout: 5000
      };
      this.toasterService.pop(toast);
      return false;
    }

    return true;
  }

  changePlace(selected) {
    this.switchOfferDetailsType(selected);
    this.initialLoadRestaurant = false;
    this.initialLoadBar = false;

    setTimeout(() => {
      this.sliderComponents.forEach(slider => {

        slider.setCurrentValuePositionEvent();

      });
    });

  }

  deleteVenueConfirmed() {
    this.buttonsEnabled = false;
    this.venueDetailsService.delete(this.venue.id).subscribe((r) => {
      this.showVenueChange.emit(true);
      this.close(true);
    }, (error) => {
      this.deleteVenue = false;
      this.buttonsEnabled = true;
    });
  }

  changeTab(selected) {
    this.activeTab = selected;

    if (selected === 5) {
      setTimeout(() => {
        this.map = new google.maps.Map(document.getElementById('map'), {
          center: { lat: this.latitude, lng: this.longitude },
          zoom: 17,
          disableDefaultUI: true
        });
        const marker = new google.maps.Marker({
          map: this.map,
          position: { lat: this.latitude, lng: this.longitude },

        });
      }, 100);
    }

    if (selected === 6) {
      if (this.statusHasChangedRestaurant || this.statusHasChangedBar) {
        this.initOffers(false, null);
      }

      if (this.venueTypeChanged) {
        this.initOffers(false, null);
        this.venueTypeChanged = false;
      }

      this.clearTotalBillAndMaxPartySize();

      this.sliderComponents.forEach(slider => {

        setTimeout(() => {
          slider.setCurrentValuePositionEvent();
        }, 30);
      });

    }

    if (this.hasRestaurant) {
      this.switchOfferDetailsType(1);
    } else {
      this.switchOfferDetailsType(2);
    }
  }

  codeAddress() {
    let position;
    this.geocoder.geocode({ 'address': this.venue.address }, (results, status) => {
      if (status === 'OK') {
        this.map = new google.maps.Map(document.getElementById('map'), {
          zoom: 17,
          disableDefaultUI: true
        });
        position = results[0].geometry.location;
        this.map.setCenter(results[0].geometry.location);
        const marker = new google.maps.Marker({
          map: this.map,
          position: results[0].geometry.location,
        });
      } else {
        alert('Geocode was not successful for the following reason: ' + status);
      }
    });

    setTimeout(() => {
      this.latitude = position.lat();
      this.longitude = position.lng();
      this.venue.location.latitude = this.latitude;
      this.venue.location.longitude = this.longitude;
    }, 1000);

  }

  barExclusionsChanged() {
    for (let i = 1; i < 7; i++) {
      this.barOffers[i].exclusions = this.barOffers[0].exclusions;
    }
  }

  restaurantExclusionsChanged() {
    for (let i = 1; i < 7; i++) {
      this.restaurantOffers[i].exclusions = this.restaurantOffers[0].exclusions;
    }
  }


  showAddCoverPopup() {
    this.showAddCover = true;
  }

  addCover(cover: VenueDetailsVisit) {
    this.venue.visits.unshift(cover);
    this.showAddCover = false;
    this.refreshVisitsList();
  }

  exportData() {

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.filteredVisits.map(z => {
      return {
        'DATE & TIME': new DatePipe('en-GB').transform(z.timeOfVisit, 'yyyy-MM-dd HH:mm'),
        COVERS: z.partySize,
        'RATE PER COVER': z.ratePerCover,
        'MEMBER NAME': z.memberName,
        'MEMBERSHIP NO': z.membershipNumber,
        'PERK': z.isPerkUsed,
        TYPE: z.type
      }
    }));
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, 'covers.xlsx');
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: ".xlsx" });
    FileSaver.saveAs(data, fileName);
  }



  switchToGroup() {
    if (this.buttonsEnabled) {
      if (this.StateChanged()) {
        this.showSwitchToGroup = true;
      } else {
        this.switchToGroupConfirmed();
      }
    }
  }

  switchToGroupConfirmed() {
    this.showSwitchToGroup = false;
    if (this.selectedGroupId) {
      this.switchToGroupEvent.emit(this.selectedGroupId);
    } else {
      this.switchToGroupEvent.emit(this.venue.groupId);
    }

  }

  groupSaveSwitch() {
    this.showSwitchToGroup = false;

    this.saveConfirmed();

    if (this.selectedGroupId) {
      this.switchToGroupEvent.emit(this.selectedGroupId);
    } else {
      this.switchToGroupEvent.emit(this.venue.groupId);
    }

    // this.venueSave();
  }


  SaveInitialState() {
    this.initialState =
      JSON.stringify(this.restaurantSubsidiaryData) +
      JSON.stringify(this.barSubsidiaryData) +
      JSON.stringify(this.venue) +
      JSON.stringify(this.selectedVenueType.id) +
      JSON.stringify(this.selectedRestaurantStatus) +
      JSON.stringify(this.selectedBarStatus) +
      JSON.stringify(this.selectedMaxPartySizeBar) +
      JSON.stringify(this.selectedMaxPartySizeRestaurant) +
      JSON.stringify(this.selectedLocation) +
      JSON.stringify(this.selectedSubArea) +
      JSON.stringify(this.barImages) +
      JSON.stringify(this.restaurantImages) +
      JSON.stringify(this.venue.contacts) +
      JSON.stringify(this.restaurantOffers) +
      JSON.stringify(this.barOffers);
  }


  StateChanged() {
    const currentState =
      JSON.stringify(this.restaurantSubsidiaryData) +
      JSON.stringify(this.barSubsidiaryData) +
      JSON.stringify(this.venue) +
      JSON.stringify(this.selectedVenueType.id) +
      JSON.stringify(this.selectedRestaurantStatus) +
      JSON.stringify(this.selectedBarStatus) +
      JSON.stringify(this.selectedMaxPartySizeBar) +
      JSON.stringify(this.selectedMaxPartySizeRestaurant) +
      JSON.stringify(this.selectedLocation) +
      JSON.stringify(this.selectedSubArea) +
      JSON.stringify(this.barImages) +
      JSON.stringify(this.restaurantImages) +
      JSON.stringify(this.venue.contacts) +
      JSON.stringify(this.restaurantOffers) +
      JSON.stringify(this.barOffers);
    return currentState !== this.initialState || currentState.length !== this.initialState.length;
  }

  SaveInitialOffersRestaurantState() {
    this.initialOffersRestaurantState =
      JSON.stringify(this.restaurantOffers);
  }


  StateOffersRestaurantChanged() {
    const currentOffersRestaurantState =
      JSON.stringify(this.restaurantOffers);
    return currentOffersRestaurantState !== this.initialOffersRestaurantState || currentOffersRestaurantState.length !== this.initialOffersRestaurantState.length;
  }

  SaveInitialOffersBarState() {
    this.initialOffersBarState =
      JSON.stringify(this.barOffers);
  }


  StateOffersBarChanged() {
    const currentOffersBarState =
      JSON.stringify(this.barOffers);
    return currentOffersBarState !== this.initialOffersBarState || currentOffersBarState.length !== this.initialOffersBarState.length;
  }

  addressSearch(value) {
    if (value) {
      this.venue.address = value;
      this.codeAddress();
    }
  }



  onChangeRestaurantStatus() {

    if (!this.validate()) {
      this.buttonsEnabled = true;
      this.cancelRestaurantStatusChange();
      this.changeRestaurantStatus = true;
      return;
    }

    this.restaurantOffers = new Array<VenueDetailsOffer>();

    for (const offer of this.oldOffersRestaurant) {


      const o = Object.assign({}, offer);
      this.restaurantOffers.push(o);

    }


    this.clearOfferLabels();

    this.statusHasChangedRestaurant = true;

    this.initialLoadRestaurant = true;

    this.pendingRestaurantStatus = this.selectedRestaurantStatus;


    this.disableMaxPartySizeRestaurant = false;
    this.disableOfferTypeRestaurant = false;

    this.SaveInitialOffersRestaurantState();

    if (this.venue.id) {
      this.saveConfirmed();
    } else {
      this.changeRestaurantStatus = false;
    }

  }

  onChangeBarStatus() {

    if (!this.validate()) {
      this.buttonsEnabled = true;
      this.cancelBarStatusChange();
      this.changeBarStatus = true;
      return;
    }

    this.barOffers = new Array<VenueDetailsOffer>();


    for (const offer of this.oldOffersBar) {


      const o = Object.assign({}, offer);

      this.barOffers.push(o);


    }


    this.clearOfferLabels();

    this.statusHasChangedBar = true;

    this.initialLoadBar = true;
    this.pendingBarStatus = this.selectedBarStatus;

    this.disableMaxPartySizeBar = false;
    this.disableOfferTypeBar = false;

    this.SaveInitialOffersBarState();

    if (this.venue.id) {
      this.saveConfirmed();
    } else {
      this.changeBarStatus = false;
    }
  }


  clearOfferLabels() {
    this.offerOptionsRestaurantDirty = false;
    this.offerOptionsBarDirty = false;
    this.maxPartySizeOptionsRestaurantDirty = false;
    this.maxPartySizeOptionsBarDirty = false;
    this.offerTypeChangeBarLabel = '';
    this.offerTypeChangeRestaurantLabel = '';
    this.maxPartySizeChangeBarLabel = '';
    this.maxPartySizeChangeRestaurantLabel = '';
  }

  changeRestaurantStatusConfirmation(item: EnumModel) {
    if (this.pendingRestaurantStatus.id === item.id) {
      return;
    }

    // if (!this.StateOffersRestaurantChanged()) {
    //   this.onChangeRestaurantStatus();
    //   return;
    // }

    this.changeRestaurantStatus = true;
  }

  changeBarStatusConfirmation(item: EnumModel) {
    if (this.pendingBarStatus.id === item.id) {
      return;
    }

    // if (!this.StateOffersBarChanged()) {
    //   this.onChangeBarStatus();
    //   return;
    // }

    this.changeBarStatus = true;
  }

  cancelRestaurantStatusChange() {
    this.selectedRestaurantStatus = this.pendingRestaurantStatus;
    this.changeRestaurantStatus = false;
  }

  cancelBarStatusChange() {
    this.selectedBarStatus = this.pendingBarStatus;
    this.changeBarStatus = false;
  }

  clearTotalBillAndMaxPartySize() {

    if (this.statusHasChangedRestaurant) {

      for (const offer of this.venue.offers) {

        if (this.selectedOfferOptionRestaurant.id === 'increase' || this.selectedOfferOptionRestaurant.id === 'decrease') {
          this.offerOptionsRestaurant.pop();
          if (offer.totalBill) {
            this.selectedOfferOptionRestaurant = this.offerOptionsRestaurant[1];
          } else {
            this.selectedOfferOptionRestaurant = this.offerOptionsRestaurant[0];
          }
        }

        if (this.selectedMaxPartySizeRestaurant.id === 'increase' || this.selectedMaxPartySizeRestaurant.id === 'decrease') {
          this.maxPartySizeOptionsRestaurant.pop();
          if (offer.maxPartySize) {
            this.selectedMaxPartySizeRestaurant = EnumModel.GetByIdOrFirst(this.maxPartySizeOptionsRestaurant, offer.maxPartySize.toString());
          } else {
            this.selectedMaxPartySizeRestaurant = this.maxPartySizeOptionsRestaurant[0];
          }

        }
      }
    }


    if (this.statusHasChangedBar) {
      for (const offer of this.venue.offers) {
        if (this.selectedOfferOptionBar.id === 'increase' || this.selectedOfferOptionBar.id === 'decrease') {
          this.offerOptionsBar.pop();
          if (offer.totalBill) {
            this.selectedOfferOptionBar = this.offerOptionsBar[1];
          } else {
            this.selectedOfferOptionBar = this.offerOptionsBar[0];
          }
        }

        if (this.selectedMaxPartySizeBar.id === 'increase' || this.selectedMaxPartySizeBar.id === 'decrease') {
          this.maxPartySizeOptionsBar.pop();
          if (offer.maxPartySize) {
            this.selectedMaxPartySizeBar = EnumModel.GetByIdOrFirst(this.maxPartySizeOptionsBar, offer.maxPartySize.toString());
          } else {
            this.selectedMaxPartySizeBar = this.maxPartySizeOptionsBar[0];
          }
        }
      }
    }


  }

  checkOfferConditions(offer: VenueDetailsOffer): boolean {
    return !(!offer.isLive && offer.showPendingTrueIsLive) && !(offer.isLive && !offer.showPendingFalseIsLive);
  }

  onLiveStatusChange(i: number, offerType: 'restaurant' | 'bar'): void {
    let offer: VenueDetailsOffer;
    let oldOfferStatus: boolean;


    if (offerType === 'restaurant') {
      offer = this.restaurantOffers[i];
      oldOfferStatus = this.oldOffersRestaurant[i].isLive;
    } else if (offerType === 'bar') {
      offer = this.barOffers[i];
      oldOfferStatus = this.oldOffersBar[i].isLive;
    }

    offer.isLiveDirty = true;


    this.updateOfferIsLive(offer, oldOfferStatus ? 'pendingFalse' : 'pendingTrue', true);

  }

  onPendingTrueFalseStatusChange(offer: VenueDetailsOffer): void {

    offer.isLiveDirty = true;

    this.updateOfferIsLive(offer, 'initial', true);
  }

  onDayChange(offer: VenueDetailsOffer): void {

    if (!offer.isLive) {
      offer.perk = false;
    }
  }

  updateBulkNotifications(notify: boolean) {
    this.isBulkNotifications = notify;
  }

  private updatePerkFlagsBeforeSave(offer: VenueDetailsOffer, oldOffer: VenueDetailsOffer): void {

    if (offer.showPendingTruePerk) {
      offer.pendingPerk = true;
    }

    if (offer.showPendingFalsePerk) {
      offer.pendingPerk = false;
    }

    if (offer.showInitialPerk) {
      offer.pendingPerk = oldOffer.perk;
    }

    if (!offer.perkDirty) {
      offer.pendingPerk = null;
    }
  }

}




























// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/venues/venue-details/venue-details.component.ts